import "./newTeeSheetTabsDivision.scss";
import React, { Fragment, useEffect, useState } from "react";
import { ITeeTimeTabNew } from "./NewTeeSheet";
import { findTeeTimeIdClosestToLookbackAnchor } from "./findTeeTimeIdClosestToAnchorMinutes";
import { useTeeSheetNavigationAutoScroll } from "./useTeeSheetNavigationAutoScroll";
import {
  calculateDivisionColors,
  IAddSqueezeTimeModal,
  IAddTeeTimeModal,
  IAuditTrailModal,
  ICancelBookingPopup,
  ICancelPlayerPopup,
  ICreateShotgunModal,
  IEditStartHoleModal,
  IFileImportModal,
  ICheckInAllLeagueParticipantsModal,
  ICheckInPlayerPopup,
  INewTeeSheetTabsDragAndDropState,
  INewTeeSheetTabsState,
  INoShowModal,
  IRemoveShotgunPopup,
  IRemoveTeeTimePopup,
  ICheckInAllShotGunParticipantsModal,
  ITeeTimeDetailsModal,
  ITeeTimeDraggable,
  ICheckInAllTournamentParticipantsModal,
  IPrintCartSignsModal,
  IPrintScoreCardModal,
  IImportPlayersFileModal,
  ILotteryModal,
  IEditLotteryModal,
  ILotteryBuild,
  ILotteryBuildCustomer,
  IPowerCartNumbersModal,
  IIssueRainCheckModal,
  IEditShotgunPopup,
} from "./NewTeeSheetTabs";
import { IBooking, ITeeTime, ITeeTimeBookingCategory, ITeeTimeSlotNew } from "redux/reducers/models/teetime";
import classNames from "classnames";
import {
  faCheckCircle,
  faCircleG,
  faEllipsisV,
  faLocationCheck,
  faMessageCheck,
  faUsdCircle,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faExclamationCircle,
  faBan,
  faCircle,
  faPersonWalking,
  faPlusCircle,
  faRepeatAlt,
  faThunderstorm,
  faStickyNote,
  faSunrise,
  faSunset,
  faTrophy,
  faUsers,
  faTriangleExclamation,
  faCrown,
  faUserGroup,
  faUser,
  faCreditCard,
  faHourglassClock,
  faTag,
  faFlag,
  faArrowUTurnUpRight,
  faPersonGolfing,
} from "@fortawesome/pro-regular-svg-icons";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import RightClickMenu from "components/rightClickMenu/RightClickMenu";
import { Badge } from "components/badge/Badge";
import { CustomIcon } from "components/customIcon/CustomIcon";
import BookingSourceLogo from "components/bookingSourceLogo/BookingSourceLogo";
import BookingSourceIcon from "components/bookingSourceLogo/BookingSourceIcon";
import { NavigationDropdownNew } from "components/navigationDropdownNew/NavigationDropdownNew";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { loadingTeetimeTabActionsContainsId, TNewTeeSheetLoadingTeetimeTabAction } from "./loadingTeetimeTabActions";
import Spin from "components/spin/spin";
import { convertTime, formatDate, valueToString, convertHoles } from "helpers/Helpers";
import { isTurnBlockedForEighteenHoles } from "helpers/teeSheetTurn";
import { getTeeTimeSlotWrapJoinClasses } from "helpers/teeSheetSlotWrapJoins";
import { getSunsetLinePlacementTime } from "helpers/sunsetLinePlacementTime";
import { Draggable, Droppable } from "react-beautiful-dnd";
import moment from "moment";
import TeeTimeToolTip, { ITeeTimeToolTipPricing } from "components/teeTimeToolTip/teeTimeToolTip";
import { useHistory } from "react-router";
import { ILeague } from "redux/reducers/models/league";
import { ITournament } from "redux/reducers/models/tournament";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { IDivision } from "redux/reducers/models/facility";
import {
  ExportShotgunTemplate,
  ExportTeeTimesTemplate,
  GetPrintEventAlphaList,
  GetTeeTime,
  GetTeeTimeLotteryRequest,
  GetTeeTimePricing,
  PutTeeTime,
} from "api/rpc/2024-04/facilityAdmin/teesheet/teeSheet";
import { StatusCode } from "api/protocols";
import { dequeue, enqueue, showError, showSuccess } from "redux/actions/ui";
import axios, { CancelToken } from "axios";
import { useDivisionBreakpoints } from "elements/teesheet/useDivisionBreakpoints";
import BookingParticipantName from "elements/teesheet/BookingParticipantName";
import { BookingParticipantTabletLayout } from "elements/teesheet/BookingParticipantTabletLayout";
import {
  ITeeSheetSideBySideSettings,
  TTeeSheetView,
} from "hooks/useTeeSheetSideBySideSettings/useTeeSheetSideBySideSettings";
import { GetTournamentOrganizer } from "api/rpc/2024-04/facilityAdmin/tournament/organizer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ILottery } from "redux/reducers/models/lottery";
import { GetLeagueOrganizer } from "api/rpc/2024-04/facilityAdmin/league/organizer";
import useModal from "hooks/modals/useModal";
import Sheet from "components/sheet/Sheet";
import Portal from "elements/Portal";
import DatePickerInput from "components/datePickerInput/DatePickerInput";
import {
  GetCopyLeagueBookingPreview,
  PutBookingGroup,
  PutCancelBookingGroup,
  PutCopyLeagueBookings,
  GetBookingNotes,
  GetBooking,
  GetCartWaiver,
} from "api/rpc/2024-04/facilityAdmin/teesheet/booking";
import Callout from "components/callout/Callout";
import FormLayout from "components/form/FormLayout";
import PaceTrackerContextInfo from "elements/teesheet/paceTracker/PaceTrackerContextInfo";
import { isSlotOverPace } from "elements/teesheet/paceTracker/paceTrackerUtils";
import Input from "components/form/input";
import Popup from "components/popup/Popup";
import Checkbox from "components/form/checkbox/Checkbox";
import { GetCustomerNotes } from "api/rpc/2024-04/facilityAdmin/customer/customer";
import { TCustomerNote } from "pages/guest/Portal/Billing/context/contextTypes";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import { TABLET_WIDTH } from "helpers/ScreenSizes";

export enum NewTeeSheetTabsDivisionUpdateModalType {
  NoShow = "NoShow",
  CreateShotgun = "CreateShotgun",
  AuditTrail = "AuditTrail",
  TeeTimeDetails = "TeeTimeDetails",
  EditStartHole = "EditStartHole",
  AddTeeTime = "AddTeeTime",
  AddSqueezeTime = "AddSqueezeTime",
  FileImport = "FileImport",
  RemoveShotgun = "RemoveShotgun",
  EditShotgun = "EditShotgun",
  CheckInAllLeagueParticipants = "CheckInAllLeagueParticipants",
  CheckInAllTournamentParticipants = "CheckInAllTournamentParticipants",
  CheckInAllShotgunParticipants = "CheckInAllShotgunParticipants",
  CancelBooking = "CancelBooking",
  CancelPlayer = "CancelPlayer",
  BlockedTeeTime = "BlockedTeeTime",
  RemoveTeeTime = "RemoveTeeTime",
  SelectDivisions = "SelectDivisions",
  AddTournamentPlayer = "AddTournamentPlayer",
  PrintCartSigns = "PrintCartSigns",
  ImportPlayersFile = "ImportPlayersFile",
  Lottery = "Lottery",
  LotteryRequests = "LotteryRequests",
  EditLottery = "EditLottery",
  BuildLottery = "BuildLottery",
  FinalizeLottery = "FinalizeLottery",
  PrintScoreCards = "PrintScoreCards",
  CheckInPlayer = "CheckInPlayer",
  PowerCartNumbers = "PowerCartNumbers",
  IssueRainCheck = "IssueRainCheck",
}

interface INewTeeSheetTabsDivisionProps {
  divisionClassName?: string;
  teeSheetView: TTeeSheetView;
  sortedTeeTimes: ITeeTimeTabNew[];
  groupedTeeTimes: ITeeTimeDraggable[];
  teetimeBookingCategories: ITeeTimeBookingCategory[][];
  dragAndDropState: INewTeeSheetTabsDragAndDropState;
  loadingTeetimeTabActions: TNewTeeSheetLoadingTeetimeTabAction[];
  teeSheetLeagues: ILeague[];
  teeSheetTournaments: ITournament[];
  teeSheetLotteries: ILottery[];
  allDivisions: IDivision[];
  handleInitiateBooking: (teetime: ITeeTimeTabNew, slot?: ITeeTimeSlotNew, groupBookingId?: string) => Promise<void>;
  handleEditBooking: (teetime: ITeeTimeTabNew, bookingId: number) => Promise<void>;
  updateModalState<T>(newState: Partial<T> & { isOpen?: boolean }, type: NewTeeSheetTabsDivisionUpdateModalType): void;
  updateMainState(newMainState: Partial<INewTeeSheetTabsState>): void;
  handleSelectDivisions(teetime: ITeeTimeTabNew): void;
  handleInitiateLottery: (teetime: ITeeTimeTabNew, slot?: ITeeTimeSlotNew) => Promise<void>;
  lotteryBuilds: Array<ILotteryBuild>;
  jumpToTime: string;
  navigationKey: string;
  preferredDivisionId?: number;
  reloadTeeTimeTabs: () => void;
  duplicateBookingModal: { isOpen: boolean; booking: IBooking; teeTime: ITeeTime };
  updateDuplicateBookingModal: (newState: Partial<{ isOpen: boolean; booking: IBooking; teeTime: ITeeTime }>) => void;
  registerSideBySideScrollContainer?: (divisionId: number, el: HTMLDivElement | null) => void;
  onSideBySideDivisionScroll?: (divisionId: number, event: React.UIEvent<HTMLDivElement>) => void;
  sideBySideScrollDivisionId?: number;
  sideBySideSettings: ITeeSheetSideBySideSettings;
}

function renderBookingNoteTooltip(note: TCustomerNote | null) {
  if (!note) {
    return <Spin />;
  }

  return (
    <>
      <FontAwesomeIcon icon={faUser} /> {`${note.author?.initials}: ${note.content}`}
      {note.created_at ? (
        <>
          <br />
          {moment(note.created_at).format("LLL")}
        </>
      ) : null}
    </>
  );
}

export default function NewTeeSheetTabsDivision(props: INewTeeSheetTabsDivisionProps) {
  const history = useHistory();
  const { t } = useTranslation();
  const { facilityStore, teeSheetStore } = useAppSelector(store => store);
  const windowSize = useWindowSize();
  const dispatch = useAppDispatch();
  const {
    state: copyLeagueBookings,
    updateModal: updateCopyLeagueBookings,
    closeModal: closeCopyLeagueBookings,
  } = useModal<{
    bookingIds: Array<number>;
    selectedDate: Date;
    leagueId: number;
    startTime: string;
    endTime: string;
    divisionId: number;
    copyStatus: { copy_status: string; results: Array<{ start_time: string }> };
  }>({
    bookingIds: [],
    selectedDate: teeSheetStore.selectedDate ? (teeSheetStore?.selectedDate as Date) : new Date(),
    leagueId: null,
    startTime: "",
    endTime: "",
    divisionId: null,
    copyStatus: null,
  });

  const {
    state: editGroupNameModal,
    updateModal: updateEditGroupNameModal,
    closeModal: closeEditGroupNameModal,
  } = useModal<{ groupName: string; groupId: string }>({ groupName: "", groupId: "" });
  const {
    state: cancelGroupBookingsModal,
    updateModal: updateCancelGroupBookingsModal,
    closeModal: closeCancelGroupBookingsModal,
  } = useModal<{ groupId: string; cancelEmail: boolean }>({ groupId: "", cancelEmail: true });

  const {
    divisionRef,
    divisionWidth,
    useViewportBreakpoints,
    mobileSizedDivision,
    compactTabletSizedDivision,
    showTabletBookingNoteIcon,
    tabletBookingParticipantLayout,
    slotWrapSizedDivision,
  } = useDivisionBreakpoints(props.navigationKey, {
    useViewportBreakpoints: props.teeSheetView !== "side-by-side",
  });

  const [bookingNotes, setBookingNotes] = useState<TCustomerNote>(null);
  const [highPriorityNotes, setHighPriorityNotes] = useState<TCustomerNote>(null);

  useEffect(() => {
    const source = axios.CancelToken.source();
    if (copyLeagueBookings.isOpen) {
      if (copyLeagueBookings.selectedDate?.getDate() !== (teeSheetStore?.selectedDate as Date)?.getDate()) {
        void getCopyLeagueBookingsPreview(source?.token);
      }
    }
    return () => source.cancel();
  }, [copyLeagueBookings?.isOpen, copyLeagueBookings?.selectedDate]);

  async function getCopyLeagueBookingsPreview(cancelToken: CancelToken) {
    if (copyLeagueBookings?.copyStatus !== null) {
      //loader
      void updateCopyLeagueBookings({ copyStatus: null });
    }

    const res = await GetCopyLeagueBookingPreview(
      {
        booking_ids: copyLeagueBookings?.bookingIds,
        target_date: formatDate(copyLeagueBookings?.selectedDate),
        league_id: copyLeagueBookings?.leagueId,
        start_time: copyLeagueBookings?.startTime,
        end_time: copyLeagueBookings?.endTime,
        division_id: copyLeagueBookings?.divisionId,
      },
      false,
      cancelToken,
    );
    if (res?.status !== StatusCode.OK) {
      if (cancelToken && cancelToken.reason) {
        return;
      }
      dispatch(showError(typeof res?.data === "string" ? res?.data : t("Error getting copy league bookings preview")));
      return;
    }

    void updateCopyLeagueBookings({ copyStatus: res?.data });
  }

  async function putCopyLeagueBookings() {
    const res = await PutCopyLeagueBookings(
      {
        target_date: formatDate(copyLeagueBookings?.selectedDate),
        league_id: copyLeagueBookings?.leagueId,
        start_time: copyLeagueBookings?.startTime,
        end_time: copyLeagueBookings?.endTime,
        division_id: copyLeagueBookings?.divisionId,
        booking_ids: copyLeagueBookings?.bookingIds,
      },
      true,
    );
    if (res?.status !== StatusCode.OK) {
      dispatch(showError(typeof res?.data === "string" ? res?.data : t("Error copying league bookings")));
      return;
    }

    dispatch(showSuccess(t("Successfully copied league bookings")));
    void closeCopyLeagueBookings();
  }

  const renderBookingParticipantIcons = (
    slot: ITeeTimeSlotNew,
    options?: { includeHoles?: boolean; hideCheckInStatusIcons?: boolean },
  ) => {
    const includeHoles = options?.includeHoles !== false;
    const hideCheckInStatusIcons = options?.hideCheckInStatusIcons === true;
    const highlight =
      facilityStore.teeSheetSettings.highlight_new_bookings &&
      moment
        .utc(slot.tee_time_bookings_completed_at)
        .local()
        .isSameOrAfter(moment().subtract({ hours: facilityStore?.teeSheetSettings.highlight_new_bookings_window })) &&
      moment.utc(slot.tee_time_bookings_completed_at).local().isSameOrBefore(moment()) &&
      slot.check_in_status === "unchecked";

    const overPace = isSlotOverPace(slot, facilityStore?.facility?.holes ?? 18, facilityStore?.teeSheetSettings);

    return (
      <>
        {slot.check_in_status === "arrived" && (
          <FontAwesomeIcon icon={faLocationCheck} className="booking-participant_icon" />
        )}

        {highlight && !overPace ? (
          <Badge size="small" type="warning">
            {t("New")}
          </Badge>
        ) : null}

        {!hideCheckInStatusIcons &&
          slot.check_in_status !== "checked" &&
          slot?.check_in_status !== "arrived" &&
          !slot.no_show_type &&
          !highlight &&
          (slot.reminder_confirmed_at ? (
            <OverlayTrigger placement="top" overlay={<Tooltip id={"confirmed-icon"}>{t("Confirmed")}</Tooltip>}>
              <FontAwesomeIcon icon={faMessageCheck} className="booking-participant_icon" />
            </OverlayTrigger>
          ) : (
            <FontAwesomeIcon icon={faCircle} className="booking-participant_icon" />
          ))}

        {slot.turn === 1 && <FontAwesomeIcon icon={faRepeatAlt} className="booking-participant_icon" />}

        {slot.order_financial_status === "paid" && (
          <FontAwesomeIcon icon={faUsdCircle} className="booking-participant_icon" />
        )}

        {slot.tee_time_booking_participant_pre_paid ? (
          <OverlayTrigger placement="top" overlay={<Tooltip id={"prepaid-icon"}>{t("Prepaid")}</Tooltip>}>
            <FontAwesomeIcon icon={faCreditCard} className="booking-participant_icon" />
          </OverlayTrigger>
        ) : null}

  {slot?.tee_time_booking_participant_finish_time ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="finish-time-tooltip" className="tee_off_tooltip">
              {t("Finish time recorded at")}{" "}
              {moment
                .utc(slot.tee_time_booking_participant_finish_time, "YYYY-MM-DD HH:mm:ss")
                .local()
                .format("LT")}
            </Tooltip>
          }
        >
          <FontAwesomeIcon icon={faFlag} className="booking-participant_icon" />
        </OverlayTrigger>
      ) : slot?.tee_time_booking_participant_turn_time ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="turn-time-tooltip" className="tee_off_tooltip">
              {t("Turn time recorded at")}{" "}
              {moment
                .utc(slot.tee_time_booking_participant_turn_time, "YYYY-MM-DD HH:mm:ss")
                .local()
                .format("LT")}
            </Tooltip>
          }
        >
          <FontAwesomeIcon icon={faArrowUTurnUpRight} className="booking-participant_icon" />
        </OverlayTrigger>
      ) : slot?.tee_time_booking_participant_tee_off_time ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tee-off-time-tooltip" className="tee_off_tooltip">
              {t("Tee off recorded at")}{" "}
              {moment
                .utc(slot.tee_time_booking_participant_tee_off_time, "YYYY-MM-DD HH:mm:ss")
                .local()
                .format("LT")}
            </Tooltip>
          }
        >
          <FontAwesomeIcon icon={faPersonGolfing} className="booking-participant_icon" />
        </OverlayTrigger>
      ) : (
        !hideCheckInStatusIcons &&
        slot.check_in_status === "checked" && (
          <FontAwesomeIcon icon={faCheckCircle} className="booking-participant_icon" />
        )
      )}

        {slot.no_show_type && slot.no_show_type !== "weather" && (
          <FontAwesomeIcon icon={faBan} className="booking-participant_icon" />
        )}

        {slot.no_show_type === "weather" && (
          <FontAwesomeIcon icon={faThunderstorm} className="booking-participant_icon" />
        )}

        {!mobileSizedDivision && includeHoles && (
          <div className="booking-participant-holes-large">
            {convertHoles(
              slot.tee_time_bookings_holes,
              facilityStore.facility?.courses?.find(course => course.id === slot.course_id),
            )}
          </div>
        )}

        {overPace ? <FontAwesomeIcon icon={faHourglassClock} className="booking-participant_icon" /> : null}
      </>
    );
  };

  const renderBookingCategoryIcons = (teeTimeId: number) => {
    if (!props.teetimeBookingCategories || props.sideBySideSettings?.hideBookingCategories) {
      return;
    }

    const bookingCategories = props.teetimeBookingCategories[teeTimeId];

    if (!bookingCategories) {
      return;
    }

    return (
      <div className="booking-category-icons">
        {bookingCategories?.map((category: ITeeTimeBookingCategory, index: number) => {
          const categoryLabel = category?.title[0]?.toLocaleLowerCase();
          return (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`category-${category.title}`}>{category.title}</Tooltip>}
              key={index}
            >
              <FontAwesomeIcon
                icon={["far", `circle-${categoryLabel}` as IconName]}
                className="booking-category-icon"
              />
            </OverlayTrigger>
          );
        })}
      </div>
    );
  };

  const renderPromotionIcon = (slot: ITeeTimeSlotNew) => {
    if (!slot?.promotion_type || slot?.promotion_value == null) {
      return null;
    }

    const discount =
      slot.promotion_type === "percent" ? `${slot.promotion_value}% off` : `$${slot.promotion_value} off`;

    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`promotion-${slot.tee_time_id}`}>
            <div>{slot.promotion_label || t("Promotion")}</div>
            <div>{t("{{discount}} online pricing", { discount })}</div>
          </Tooltip>
        }
      >
        <FontAwesomeIcon className="tee-time-promotion-icon" icon={faTag} />
      </OverlayTrigger>
    );
  };

  function convertStartTimePeriod(startTime: string) {
    const tempHours = startTime?.split(":");
    const hours = Number(tempHours?.[0]);

    if (hours == null || isNaN(hours)) {
      return "";
    }

    if (hours < 12) {
      return " AM";
    } else {
      return " PM";
    }
  }

  function findMatchingGroupedTeeTime(
    teetime: ITeeTimeTabNew,
    groupedTeeTimes: ITeeTimeDraggable[],
    totalBuildQuantity?: number,
  ): ITeeTimeDraggable {
    for (const moveGroup of props.dragAndDropState.moveGroups) {
      if (moveGroup.sourceTeeTime.slots[0][0].tee_time_id === teetime.slots[0].tee_time_id) {
        return moveGroup.sourceTeeTime;
      } else if (moveGroup.destTeeTime.slots[0][0].tee_time_id === teetime.slots[0].tee_time_id) {
        return moveGroup.destTeeTime;
      }
    }

    const foundTeeTime = groupedTeeTimes?.find(
      groupedTeeTime => groupedTeeTime.slots[0][0].tee_time_id === teetime.slots[0].tee_time_id,
    );

    //Return required amount of empty slots
    if (totalBuildQuantity) {
      let totalQuantity = totalBuildQuantity;
      return {
        ...foundTeeTime,
        slots: foundTeeTime?.slots?.filter(slotsGroup => {
          if (slotsGroup?.every(slot => slot?.tee_time_booking_id)) {
            totalQuantity += slotsGroup?.length;
            return true;
          } else if (totalQuantity < slotsGroup[0]?.size) {
            totalQuantity += slotsGroup?.length;
            return true;
          }
          return false;
        }),
      };
    } else {
      return foundTeeTime;
    }
  }

  async function handlePrintAlphaList(teetime: ITeeTimeTabNew) {
    let tournamentId = 0;
    let leagueId = 0;
    let params;

    if (teetime.slots[0].league_id) {
      leagueId = teetime.slots[0].league_id;
      params = {
        league_id: leagueId,
        tee_sheet_id: teetime.slots[0].tee_sheet_id,
      };
    } else if (teetime.slots[0].tournament_id) {
      tournamentId = teetime.slots[0].tournament_id;
      params = {
        tournament_id: tournamentId,
        tee_sheet_id: teetime.slots[0].tee_sheet_id,
      };
    }

    const alphaListRes = await GetPrintEventAlphaList(params, true);

    if (alphaListRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error printing event alpha list")));
      return;
    }

    window.open().document.write(String(alphaListRes.data));
  }

  function navigateToEventAccount(type: "league" | "tournament", eventId: number) {
    const event =
      type === "league"
        ? props.teeSheetLeagues.find(league => league.id === eventId)
        : props.teeSheetTournaments.find(tournament => tournament.id === eventId);

    history.push(`/admin/settings/accounts/overview/${event.account_id}`);
  }

  function tournamentName(id: number) {
    const tournament = props.teeSheetTournaments?.find(tournament => tournament.id === id);

    return tournament !== undefined ? tournament.name : t("Tournament");
  }

  function leagueName(id: number) {
    const league = props.teeSheetLeagues?.find(league => league.id === id);

    return league !== undefined ? league.name : t("League");
  }

  function lotteryDates(id: number) {
    const lottery = props?.teeSheetLotteries?.find(lottery => lottery?.id === id);

    return lottery !== undefined
      ? `${t("Open Date")}: ${moment(lottery?.open_date)?.format("LL")} - ${t("Close Date")}: ${moment(
          lottery?.close_date,
        )?.format("LL")}`
      : "";
  }

  function getLotteryValue(id: number, key: keyof ILottery) {
    const lottery = props?.teeSheetLotteries?.find(lottery => lottery?.id === id);

    return lottery !== undefined ? lottery[key] : null;
  }

  function tournamentNote(id: number) {
    const tournament = props.teeSheetTournaments?.find(tournament => tournament.id === id);

    return tournament !== undefined ? tournament?.tee_sheet_note : "";
  }

  function getDivisionCode(teeTimeSlot: ITeeTimeSlotNew) {
    const division = props.allDivisions?.find((division: IDivision) => division.id === teeTimeSlot?.division_id);
    const turnDivision = props?.allDivisions?.find(
      (division: IDivision) => division.id === teeTimeSlot?.turn_division_id,
    );

    if (division) {
      if (facilityStore.teeSheetSettings.display_turn_division_code) {
        const showsTurn =
          teeTimeSlot.turn_tee_time_id != null &&
          turnDivision?.code != null &&
          !isTurnBlockedForEighteenHoles(teeTimeSlot.turn_tee_time_blocked_type, teeTimeSlot.blocked_type);
        return division.code + (showsTurn ? ` - ${turnDivision.code}` : "");
      } else {
        return division.code;
      }
    } else {
      return "";
    }
  }

  async function handleMouseEnter(
    teeTime: ITeeTimeTabNew,
    token?: CancelToken,
  ): Promise<ITeeTimeToolTipPricing | undefined> {
    const pricingRes = await GetTeeTimePricing({ tee_time_id: teeTime.slots[0].tee_time_id }, false, token);

    if ((token && token.reason) || typeof pricingRes.data === "string") {
      return undefined;
    }

    if (pricingRes.status !== Number(StatusCode.OK)) {
      dispatch(showError(pricingRes.message));
      return {
        booking_fee: undefined,
        green_fees: [],
        booking_categories: [],
      };
    }

    return pricingRes.data as ITeeTimeToolTipPricing;
  }

  function findCustomerTypeBackground(slot: ITeeTimeSlotNew) {
    let color = "#FFFFFF";

    if (slot.turn) {
      color = "#e7e7e7";
    } else if (slot.no_show_type == "weather") {
      color = "#fcbf49";
    } else if (slot.no_show_type) {
      color = "#d62828";
    } else if (slot.check_in_status === "checked") {
      color = "#82d195";
    } else if (slot.customer_id) {
      color = slot.customer_type_color;
    }

    return color;
  }

  function checkForCheckedInPlayer(slotGroup: ITeeTimeSlotNew[]) {
    return slotGroup?.filter(slot => slot.check_in_status !== "unchecked")?.length > 0;
  }

  async function handleExportShotgunTemplate(teeTime: ITeeTimeTabNew) {
    const params = {
      shotgun_application_id: teeTime.slots[0].shotgun_application_id,
    };

    const exportRes = await ExportShotgunTemplate(params, true);

    if (exportRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error exporting shotgun template")));
      return;
    }

    const templateExport = document.createElement("a");
    templateExport.href = "data:text/csv;charset=utf-8," + encodeURI(String(exportRes.data));
    templateExport.target = "_blank";
    templateExport.download = `${t("Shotgun_Template")}_${moment(new Date()).format("YYYY-MM-DD").toString()}`
      .replace(/ /g, "_")
      .toLowerCase()
      .concat(".csv");
    templateExport.click();
  }

  async function handleExportLeagueTeeTimesTemplate(teeTime: ITeeTimeTabNew, teeTimeIndex: number) {
    if (!props?.sortedTeeTimes) {
      console.error("props.sortedTeeTimes is undefined", props?.sortedTeeTimes);
      return;
    }

    const startTime = teeTime?.slots[0]?.start_time;
    let endTime = "";
    const leagueId = teeTime?.slots[0]?.league_id;
    //Get end time of the tournament
    for (let i = teeTimeIndex; i < props?.sortedTeeTimes?.length; i++) {
      if (props?.sortedTeeTimes[i]?.slots[0]?.league_id === leagueId) {
        //set current tee time as the end time
        endTime = props?.sortedTeeTimes[i]?.slots[0]?.start_time;
      } else {
        //tee time is not a part of the league, break the loop
        break;
      }
    }
    if (!leagueId || !endTime) {
      dispatch(showError(t("Error exporting tee time template")));
      return;
    }

    const exportRes = await ExportTeeTimesTemplate(
      {
        tee_sheet_id: teeTime?.slots[0]?.tee_sheet_id,
        date: teeTime?.slots[0]?.date,
        start_time: startTime,
        end_time: endTime,
        league_id: leagueId,
      },
      true,
    );

    if (exportRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error exporting tee time template")));
      return;
    }

    const templateExport = document.createElement("a");
    templateExport.href = "data:text/csv;charset=utf-8," + encodeURI(String(exportRes.data));
    templateExport.target = "_blank";
    templateExport.download = `league_tee_times_${moment(new Date()).format("YYYY-MM-DD").toString()}`
      .replace(/ /g, "_")
      .toLowerCase()
      .concat(".csv");
    templateExport.click();
  }

  async function handleExportTeeTimesTemplate(teeTime: ITeeTimeTabNew, teeTimeIndex: number) {
    if (!props?.sortedTeeTimes) {
      console.error("props.sortedTeeTimes is undefined", props?.sortedTeeTimes);
      return;
    }

    const startTime = teeTime?.slots[0]?.start_time;
    let endTime = "";
    const tournamentId = teeTime?.slots[0]?.tournament_id;
    //Get end time of the tournament
    for (let i = teeTimeIndex; i < props?.sortedTeeTimes?.length; i++) {
      if (props?.sortedTeeTimes[i]?.slots[0]?.tournament_id === tournamentId) {
        //set current tee time as the end time
        endTime = props?.sortedTeeTimes[i]?.slots[0]?.start_time;
      } else {
        //tee time is not a part of the tournament, break the loop
        break;
      }
    }
    if (!tournamentId || !endTime) {
      dispatch(showError(t("Error exporting tee time template")));
      return;
    }

    const exportRes = await ExportTeeTimesTemplate(
      {
        tee_sheet_id: teeTime?.slots[0]?.tee_sheet_id,
        date: teeTime?.slots[0]?.date,
        start_time: startTime,
        end_time: endTime,
        tournament_id: tournamentId,
      },
      true,
    );

    if (exportRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error exporting tee time template")));
      return;
    }

    const templateExport = document.createElement("a");
    templateExport.href = "data:text/csv;charset=utf-8," + encodeURI(String(exportRes.data));
    templateExport.target = "_blank";
    templateExport.download = `tournament_tee_times_${moment(new Date()).format("YYYY-MM-DD").toString()}`
      .replace(/ /g, "_")
      .toLowerCase()
      .concat(".csv");
    templateExport.click();
  }

  const handleNavigateToBookingDetails = (teetimeId: number, slot: ITeeTimeSlotNew) => {
    if (slot.turn === 1) {
      return;
    }

    history.push(`/admin/teesheet/details/${teetimeId}`);
  };

  const isTodayView = formatDate(teeSheetStore.selectedDate as Date) === formatDate(new Date());

  useTeeSheetNavigationAutoScroll(
    props.navigationKey,
    props.sortedTeeTimes,
    sorted => {
      if (props.jumpToTime && props.jumpToTime !== "") {
        const offsetTime = sorted.filter(teetime => {
          const time = teetime.start_time.replace(":", "");
          return parseInt(time) >= parseInt(props.jumpToTime.replace(":", ""));
        });
        const targetTeeTimeId = offsetTime[0]?.slots?.[0]?.tee_time_id;
        if (targetTeeTimeId == null) {
          return { type: "clear" };
        }
        return { type: "scroll", teeTimeId: targetTeeTimeId, block: "start" };
      }
      if (isTodayView) {
        if (props.sideBySideSettings?.disableAutoScroll) {
          return { type: "clear" };
        }
        const targetTeeTimeId = findTeeTimeIdClosestToLookbackAnchor(sorted, props.preferredDivisionId);
        if (targetTeeTimeId == null) {
          return { type: "clear" };
        }
        return { type: "scroll", teeTimeId: targetTeeTimeId, block: "start" };
      }
      return { type: "clear" };
    },
    divisionRef,
  );

  async function handleOpenAddPlayer(slot: ITeeTimeSlotNew) {
    const res = await GetTournamentOrganizer({ tournament_id: Number(slot.tournament_id) }, true);

    if (Number(res.status) !== Number(StatusCode.OK)) {
      dispatch(showError(t("Error getting tournament organizer")));
      return;
    }

    props.updateModalState(
      { isOpen: true, slot: slot, organizer: res.data.length > 0 ? res.data[0].customer : null },
      NewTeeSheetTabsDivisionUpdateModalType.AddTournamentPlayer,
    );
  }

  async function handleOpenImportLeaguePlayers(teeTime: ITeeTimeTabNew, teeTimeIndex: number) {
    if (!props?.sortedTeeTimes) {
      console.error("props.sortedTeeTimes is undefined", props?.sortedTeeTimes);
      return;
    }

    const startTime = teeTime?.slots[0]?.start_time;
    let endTime = "";
    const leagueId = teeTime?.slots[0]?.league_id;
    //Get end time of the tournament
    for (let i = teeTimeIndex; i < props?.sortedTeeTimes?.length; i++) {
      if (props?.sortedTeeTimes[i]?.slots[0]?.league_id === leagueId) {
        //set current tee time as the end time
        endTime = props?.sortedTeeTimes[i]?.slots[0]?.start_time;
      } else {
        //tee time is not a part of the tournament, break the loop
        break;
      }
    }

    if (!leagueId || !endTime) {
      dispatch(showError(t("Error importing players")));
      return;
    }

    const res = await GetLeagueOrganizer({ league_id: Number(leagueId) }, true);

    if (res.status !== Number(StatusCode.OK)) {
      dispatch(showError(t("Error getting league organizer")));
      return;
    }

    props.updateModalState<IImportPlayersFileModal>(
      {
        isOpen: true,
        league_id: leagueId,
        date: teeTime?.slots[0]?.date,
        tee_sheet_id: teeTime?.slots[0]?.tee_sheet_id,
        start_time: startTime,
        end_time: endTime,
        organizer: res?.data?.length > 0 ? res?.data[0]?.customer : null,
      },
      NewTeeSheetTabsDivisionUpdateModalType.ImportPlayersFile,
    );
  }

  async function handleOpenImportPlayers(teeTime: ITeeTimeTabNew, teeTimeIndex: number) {
    if (!props?.sortedTeeTimes) {
      console.error("props.sortedTeeTimes is undefined", props?.sortedTeeTimes);
      return;
    }

    const startTime = teeTime?.slots[0]?.start_time;
    let endTime = "";
    const tournamentId = teeTime?.slots[0]?.tournament_id;
    //Get end time of the tournament
    for (let i = teeTimeIndex; i < props?.sortedTeeTimes?.length; i++) {
      if (props?.sortedTeeTimes[i]?.slots[0]?.tournament_id === tournamentId) {
        //set current tee time as the end time
        endTime = props?.sortedTeeTimes[i]?.slots[0]?.start_time;
      } else {
        //tee time is not a part of the tournament, break the loop
        break;
      }
    }

    if (!tournamentId || !endTime) {
      dispatch(showError(t("Error importing players")));
      return;
    }

    const res = await GetTournamentOrganizer({ tournament_id: Number(tournamentId) }, true);

    if (res.status !== Number(StatusCode.OK)) {
      dispatch(showError(t("Error getting tournament organizer")));
      return;
    }

    props.updateModalState<IImportPlayersFileModal>(
      {
        isOpen: true,
        tournament_id: tournamentId,
        date: teeTime?.slots[0]?.date,
        tee_sheet_id: teeTime?.slots[0]?.tee_sheet_id,
        start_time: startTime,
        end_time: endTime,
        organizer: res?.data?.length > 0 ? res?.data[0]?.customer : null,
      },
      NewTeeSheetTabsDivisionUpdateModalType.ImportPlayersFile,
    );
  }

  async function openLotteryRequestsModal(teetime: ITeeTimeTabNew) {
    const lotteryId = teetime?.slots[0]?.lottery_id;
    const lotteryDate = teetime?.slots[0]?.date;

    if (!lotteryId) {
      dispatch(showError(t("Lottery not found")));
      return;
    }

    const res = await GetTeeTimeLotteryRequest({ lottery_id: lotteryId }, true);
    if (res?.status !== StatusCode.OK) {
      dispatch(showError(t("Error getting lottery requests")));
      return;
    }

    const updatedRequests = res?.data?.map((data: Record<string, any>) => ({
      ...data,
      edit: false,
      customer_name_one: data?.customer_one?.full_name,
      customer_name_two: data?.customer_id_two === data?.customer_id_one ? t("Guest") : data?.customer_two?.full_name,
      customer_name_three:
        data?.customer_id_three === data?.customer_id_one ? t("Guest") : data?.customer_three?.full_name,
      customer_name_four:
        data?.customer_id_four === data?.customer_id_one ? t("Guest") : data?.customer_four?.full_name,
      players: [
        {
          id: data?.customer_id_one,
          name: data?.customer_one?.full_name,
          customer_type: data?.customer_one?.customer_type,
        },
        {
          id: data?.customer_id_two,
          name: data?.customer_id_two === data?.customer_id_one ? t("Guest") : data?.customer_two?.full_name,
          customer_type: data?.customer_two?.customer_type,
        },
        {
          id: data?.customer_id_three,
          name: data?.customer_id_three === data?.customer_id_one ? t("Guest") : data?.customer_three?.full_name,
          customer_type: data?.customer_three?.customer_type,
        },
        {
          id: data?.customer_id_four,
          name: data?.customer_id_four === data?.customer_id_one ? t("Guest") : data?.customer_four?.full_name,
          customer_type: data?.customer_four?.customer_type,
        },
      ],
    }));

    //Set build results in state
    void props.updateModalState(
      { isOpen: true, lottery_id: lotteryId, date: lotteryDate, requests: updatedRequests },
      NewTeeSheetTabsDivisionUpdateModalType.LotteryRequests,
    );
  }

  function getLotteryBuild(teetimeId: number) {
    return props?.lotteryBuilds?.find(lotteryBuild => lotteryBuild?.tee_time_id === teetimeId);
  }

  function getLotteryBuildValue(index: number, lotteryBuild: ILotteryBuild, key: keyof ILotteryBuildCustomer) {
    switch (index) {
      case 0:
        return lotteryBuild?.customer_one[key] ?? null;
      case 1:
        return lotteryBuild?.customer_two[key] ?? null;
      case 2:
        return lotteryBuild?.customer_three[key] ?? null;
      case 3:
        return lotteryBuild?.customer_four[key] ?? null;
      default:
        return lotteryBuild?.customer_one[key] ?? null;
    }
  }

  function getLotteryGuest(index: number, lotteryBuild: ILotteryBuild) {
    switch (index) {
      case 0:
        return false;
      case 1:
        return (
          lotteryBuild?.customer_id_two === null || lotteryBuild?.customer_id_two === lotteryBuild?.customer_id_one
        );
      case 2:
        return (
          lotteryBuild?.customer_id_three === null || lotteryBuild?.customer_id_three === lotteryBuild?.customer_id_one
        );
      case 3:
        return (
          lotteryBuild?.customer_id_four === null || lotteryBuild?.customer_id_four === lotteryBuild?.customer_id_one
        );
      default:
        return false;
    }
  }

  function getGroupedLotteryBuilds(teeTimeId: number) {
    return props?.lotteryBuilds?.filter(build => build?.tee_time_id === teeTimeId);
  }

  // Determines if there is a group

  function isPartOfGroup(prevTeeTime: ITeeTimeTabNew, nextTeeTime: ITeeTimeTabNew, teetime: ITeeTimeTabNew): boolean {
    const prevBookingId = prevTeeTime?.slots?.find(
      slot => slot?.tee_time_bookings_group_id,
    )?.tee_time_bookings_group_id;
    const nextBookingId = nextTeeTime?.slots?.find(
      slot => slot?.tee_time_bookings_group_id,
    )?.tee_time_bookings_group_id;
    const currBookingId = teetime?.slots?.find(slot => slot?.tee_time_bookings_group_id)?.tee_time_bookings_group_id;
    return currBookingId && (prevBookingId === currBookingId || currBookingId === nextBookingId);
  }

  function bookingGroupsHeader(nextTeeTime: ITeeTimeTabNew, teetime: ITeeTimeTabNew) {
    const nextBookingId = nextTeeTime?.slots?.find(
      slot => slot?.tee_time_bookings_group_id,
    )?.tee_time_bookings_group_id;
    const currBookingId = teetime?.slots?.find(slot => slot?.tee_time_bookings_group_id)?.tee_time_bookings_group_id;
    return nextBookingId == currBookingId;
  }

  function isFirstTeeTimeInGroup(teetime: ITeeTimeTabNew, teetimeIndex: number): boolean {
    const groupId = teetime.slots[0]?.tee_time_bookings_group_id;

    if (!groupId) {
      return false;
    }

    // Check if previous tee time has the same group ID
    const prevTeetime = props.sortedTeeTimes[teetimeIndex - 1];
    return prevTeetime === undefined || prevTeetime.slots[0]?.tee_time_bookings_group_id !== groupId;
  }

  function isLastTeeTimeInGroup(
    prevTeeTime: ITeeTimeTabNew,
    nextTeeTime: ITeeTimeTabNew,
    currentTeeTime: ITeeTimeTabNew,
  ) {
    const prevTeetime = prevTeeTime?.slots?.find(slot => slot?.tee_time_bookings_group_id)?.tee_time_bookings_group_id;
    const nextTeetime = nextTeeTime?.slots?.find(slot => slot?.tee_time_bookings_group_id)?.tee_time_bookings_group_id;
    const currentGroupId = currentTeeTime?.slots?.find(
      slot => slot?.tee_time_bookings_group_id,
    )?.tee_time_bookings_group_id;
    return currentGroupId && prevTeetime === currentGroupId && nextTeetime !== currentGroupId;
  }

  function disableCopyLeagueBookings(teeTime: ITeeTimeTabNew, teeTimeIndex: number) {
    let disable = true;
    const leagueId = teeTime?.slots[0]?.league_id;
    if (!props?.sortedTeeTimes) {
      console.error("props.sortedTeeTimes is undefined", props?.sortedTeeTimes);
      return disable;
    }

    for (let i = teeTimeIndex; i < props?.sortedTeeTimes?.length; i++) {
      if (props?.sortedTeeTimes[i]?.slots[0]?.league_id === leagueId) {
        if (props?.sortedTeeTimes[i]?.slots?.some(slot => slot?.tee_time_booking_id)) {
          //Tee time with booking found, enable copy bookings
          disable = false;
          break;
        }
      } else {
        //tee time is not a part of the league, break the loop
        break;
      }
    }

    return disable;
  }

  function openCopyLeagueBookingsModal(teeTime: ITeeTimeTabNew, teeTimeIndex: number) {
    const bookingIds: Array<number> = [];
    const leagueId = teeTime?.slots[0]?.league_id;

    if (!props?.sortedTeeTimes) {
      console.error("props.sortedTeeTimes is undefined", props?.sortedTeeTimes);
      return;
    }

    const startTime = teeTime?.slots[0]?.start_time;
    let endTime = "";

    for (let i = teeTimeIndex; i < props?.sortedTeeTimes?.length; i++) {
      if (props?.sortedTeeTimes[i]?.slots[0]?.league_id === leagueId) {
        //set current tee time as the end time
        endTime = props?.sortedTeeTimes[i]?.slots[0]?.start_time;
        props?.sortedTeeTimes[i]?.slots?.forEach(slot => {
          if (slot?.tee_time_booking_id && !bookingIds.includes(slot?.tee_time_booking_id)) {
            //Add unique league booking ids to array
            bookingIds.push(slot?.tee_time_booking_id);
          }
        });
      } else {
        //tee time is not a part of the league, break the loop
        break;
      }
    }

    if (!leagueId || !endTime) {
      dispatch(showError(t("League bookings cannot be copied")));
      return;
    }

    void updateCopyLeagueBookings({
      isOpen: true,
      bookingIds: bookingIds,
      leagueId: leagueId,
      startTime: startTime,
      endTime: endTime,
      divisionId: teeTime?.slots[0]?.division_id,
    });
  }

  async function updateBookingGroupName() {
    if (!editGroupNameModal?.groupId) {
      return;
    }

    const res = await PutBookingGroup(
      { booking_group_id: editGroupNameModal?.groupId, booking_group_name: editGroupNameModal?.groupName },
      true,
    );
    if (res?.status !== StatusCode.OK) {
      dispatch(showError(t("Error updating booking group name")));
      return;
    }
    dispatch(showSuccess(t("Successfully updated booking group name")));
    void props.reloadTeeTimeTabs();
    void closeEditGroupNameModal();
  }

  async function cancelBookingGroup() {
    if (!cancelGroupBookingsModal?.groupId) {
      return;
    }

    const res = await PutCancelBookingGroup(
      {
        booking_group_id: cancelGroupBookingsModal?.groupId,
        send_cancellation_email: cancelGroupBookingsModal?.cancelEmail,
      },
      true,
    );
    if (res?.status !== StatusCode.OK) {
      dispatch(showError(t("Error cancelling booking group")));
      return;
    }
    dispatch(showSuccess(t("Successfully cancelled all bookings within group")));
    void props.reloadTeeTimeTabs();
    void closeCancelGroupBookingsModal();
  }

  async function setBlockedType(teeTimeId: number, type: "open" | "blocked") {
    const teeTimeRes = await GetTeeTime({ id: teeTimeId }, true);

    if (Number(teeTimeRes.status) !== Number(StatusCode.OK) || !teeTimeRes.data?.[0]) {
      dispatch(showError(t("Error updating tee time")));
      return;
    }

    const updatedTeeTime = { ...teeTimeRes.data[0], blocked_type: type };
    const updateRes = await PutTeeTime({ tee_times: [updatedTeeTime] }, true);

    if (Number(updateRes.status) !== Number(StatusCode.OK)) {
      dispatch(showError(t("Error updating tee time")));
      return;
    }

    void props.reloadTeeTimeTabs();
  }

  function initiateAddToGroup(teeTime: ITeeTimeTabNew, teeTimeIndex: number) {
    let lastTeeTimeInGroup = teeTime;
    for (let i = teeTimeIndex; i < props?.sortedTeeTimes?.length; i++) {
      lastTeeTimeInGroup = props?.sortedTeeTimes[i];
      if (
        !props?.sortedTeeTimes[i]?.slots?.some(
          slot => slot?.tee_time_bookings_group_id === teeTime?.slots[0]?.tee_time_bookings_group_id,
        )
      ) {
        break;
      }
    }
    const groupBookingId = teeTime?.slots?.find(slot => slot?.tee_time_bookings_group_id)?.tee_time_bookings_group_id;

    if (lastTeeTimeInGroup && groupBookingId) {
      void props.handleInitiateBooking(lastTeeTimeInGroup, lastTeeTimeInGroup?.slots[0], groupBookingId);
    } else {
      dispatch(showError(t("There are no available tee times to add to this group")));
    }
  }

  function disableAddToGroup(teeTime: ITeeTimeTabNew, teeTimeIndex: number) {
    let lastTeeTimeInGroup = teeTime;
    for (let i = teeTimeIndex; i < props?.sortedTeeTimes?.length; i++) {
      lastTeeTimeInGroup = props?.sortedTeeTimes[i];
      if (
        !props?.sortedTeeTimes[i]?.slots?.some(
          slot => slot?.tee_time_bookings_group_id === teeTime?.slots[0]?.tee_time_bookings_group_id,
        )
      ) {
        break;
      }
    }

    if (lastTeeTimeInGroup) {
      return !lastTeeTimeInGroup?.slots?.every(
        slot => !slot?.booking_participant_id && slot?.tee_time_slot_status === "available",
      );
    }
    return true;
  }

  async function loadCartWaiver(customer_id: number, tee_time_id: number) {
    const waiverRes = await GetCartWaiver({ customer_id, tee_time_id }, true);

    if (waiverRes.status === StatusCode.OK) {
      window.open().document.write(waiverRes.data as string);
    } else {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.217")));
    }
  }

  async function handleLoadHighPriorityNotes(customerId: number) {
    setHighPriorityNotes(null);
    const res = await GetCustomerNotes({ customer_id: customerId, type: "high_priority" }, false);
    if (res?.status !== StatusCode.OK) {
      dispatch(showError(t("Error loading customer notes")));
      return;
    }
    setHighPriorityNotes(res?.data[0]);
  }

  async function handleLoadBookingNotes(bookingId: number, teeTimeBookingParticipantId: number) {
    setBookingNotes(null);
    const res = await GetBookingNotes({ tee_time_booking_participant_id: teeTimeBookingParticipantId }, false);
    if (res?.status !== StatusCode.OK) {
      dispatch(showError(t("Error loading booking notes")));
      return;
    }
    if (res?.data?.length === 0) {
      const bookingRes = await GetBookingNotes({ tee_time_booking_id: bookingId }, false);
      if (bookingRes?.status !== StatusCode.OK) {
        dispatch(showError(t("Error loading booking notes")));
        return;
      }
      setBookingNotes(bookingRes?.data[0] as TCustomerNote);
      return;
    }
    setBookingNotes(res?.data[0] as TCustomerNote);
  }

  async function initiateDuplicateBooking(bookingId: number, teeTimeId: number) {
    dispatch(enqueue());
    const [bookingRes, teeTimeRes] = await Promise.all([
      GetBooking({ id: bookingId, extended: true }, false),
      GetTeeTime({ id: teeTimeId }, false),
    ]);
    dispatch(dequeue());
    if (bookingRes?.status !== StatusCode.OK || bookingRes?.data?.length === 0) {
      dispatch(showError(typeof bookingRes?.data === "string" ? bookingRes?.data : t("Error getting booking")));
      return;
    }

    if (teeTimeRes?.status !== StatusCode.OK || teeTimeRes?.data?.length === 0) {
      dispatch(showError(typeof teeTimeRes?.data === "string" ? teeTimeRes?.data : t("Error getting tee time")));
      return;
    }

    props?.updateDuplicateBookingModal({ isOpen: true, booking: bookingRes?.data[0], teeTime: teeTimeRes?.data[0] });
  }

  const sunsetLineTime = getSunsetLinePlacementTime(facilityStore.weather?.sunset);

  return (
    <div
      ref={node => {
        divisionRef.current = node;
        if (props.sideBySideScrollDivisionId != null && props.registerSideBySideScrollContainer) {
          props.registerSideBySideScrollContainer(props.sideBySideScrollDivisionId, node);
        }
      }}
      onScroll={
        props.sideBySideScrollDivisionId != null && props.onSideBySideDivisionScroll
          ? event => props.onSideBySideDivisionScroll(props.sideBySideScrollDivisionId, event)
          : undefined
      }
      className={classNames("tee-sheet-tabs-division", {
        [props.divisionClassName]: !!props.divisionClassName,
        "tee-sheet-tabs-division--viewport-breakpoints": useViewportBreakpoints,
        "tee-sheet-tabs-division--slot-wrap": slotWrapSizedDivision,
      })}
    >
      {props.sortedTeeTimes?.map((teetime, teetimeIndex: number, teetimes) => {
        const prevTeetime = teetimes[teetimeIndex - 1];
        const nextTeetime = teetimes[teetimeIndex + 1];
        const lottery = props?.teeSheetLotteries?.find(l => l.id === teetime.slots[0].lottery_id);

        const teetimeLoading = loadingTeetimeTabActionsContainsId(
          props.loadingTeetimeTabActions,
          teetime.slots[0].tee_time_id,
        );

        // let turnArrow = false;

        // if (teetime.slots[0].turn_tee_time?.quantity_remaining < teetime.quantity_remaining) {
        //   turnArrow = true;
        // }

        return (
          <Fragment key={teetimeIndex}>
            {/* LEAGUE/TOURNAMENT/SHOTGUN HEADER */}
            {/* LEAGUE HEADER */}
            {teetime.slots[0].league_id > 0 &&
            (prevTeetime === undefined ||
              prevTeetime.slots[0].league_id === null ||
              prevTeetime.slots[0].league_id != teetime.slots[0].league_id) ? (
              <div className="tee-sheet-events-header pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>
                      <FontAwesomeIcon className="mr-2" icon={faUsers} />
                      {props.teeSheetLeagues === undefined ? (
                        <span style={{ display: "inline-flex" }}>
                          <Spin />
                        </span>
                      ) : (
                        leagueName(teetime.slots[0].league_id)
                      )}
                    </div>
                    <div className="text-black">
                      <NavigationDropdownNew
                        showPlainTextLabel
                        rightAlign
                        label={<FontAwesomeIcon className="th-ellipsis text-white" icon={faEllipsisV} />}
                        sections={[
                          [
                            {
                              icon: "print",
                              label: t("Print Cart Signs"),
                              onClick: () =>
                                props.updateModalState<IPrintCartSignsModal>(
                                  {
                                    isOpen: true,
                                    date: teetime.slots[0].date,
                                    league_id: teetime.slots[0].league_id,
                                    tournament_id: undefined,
                                    teetime,
                                    shotgun_application_id: teetime.slots[0].shotgun_application_id,
                                  },
                                  NewTeeSheetTabsDivisionUpdateModalType.PrintCartSigns,
                                ),
                            },
                            {
                              icon: "dollar-sign",
                              label: t("View Account"),
                              onClick: () => void navigateToEventAccount("league", teetime.slots[0].league_id),
                              hidden: !props.teeSheetLeagues?.find(league => league.id === teetime.slots[0].league_id)
                                ?.account_id,
                            },
                            {
                              icon: "pen",
                              label: t("Edit Shotgun"),
                              onClick: () =>
                                props.updateModalState<IEditShotgunPopup>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.EditShotgun,
                                ),
                              hidden: teetime.slots[0].shotgun_application_id === null,
                            },
                            {
                              icon: "trash",
                              label: t("Remove Shotgun"),
                              onClick: () =>
                                props.updateModalState<IRemoveShotgunPopup>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.RemoveShotgun,
                                ),
                              hidden: teetime.slots[0].shotgun_application_id === null,
                            },
                            {
                              icon: "file-export",
                              label: t("Export Shotgun Template"),
                              onClick: () => void handleExportShotgunTemplate(teetime),
                              hidden: teetime.slots[0].blocked_type !== "shotgun",
                            },
                            {
                              icon: "file-import",
                              label: t("Import Draw Sheet"),
                              onClick: () =>
                                props.updateModalState<IFileImportModal>(
                                  { isOpen: true, shotgun_application_id: teetime.slots[0].shotgun_application_id },
                                  NewTeeSheetTabsDivisionUpdateModalType.FileImport,
                                ),
                              hidden: teetime.slots[0].blocked_type !== "shotgun",
                            },
                            {
                              icon: "check",
                              label: t("Check In Participants"),
                              onClick: () =>
                                props.updateModalState<ICheckInAllLeagueParticipantsModal>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.CheckInAllLeagueParticipants,
                                ),
                            },
                            {
                              icon: "print",
                              label: t("Print Alpha List"),
                              onClick: () => void handlePrintAlphaList(teetime),
                            },
                            {
                              icon: "print",
                              label: t("Print Scorecard"),
                              onClick: () =>
                                props.updateModalState<IPrintScoreCardModal>(
                                  {
                                    isOpen: true,
                                    tournament: undefined,
                                    league: props.teeSheetLeagues.find(league => league.id),
                                    teetime,
                                  },
                                  NewTeeSheetTabsDivisionUpdateModalType.PrintScoreCards,
                                ),
                            },
                            // {
                            //   icon: "print",
                            //   label: t("Print"),
                            //   onClick: () => void handlePrintScorecards(teetime),
                            // },
                            {
                              icon: "file-export",
                              label: t("Export Template"),
                              onClick: () => void handleExportLeagueTeeTimesTemplate(teetime, teetimeIndex),
                              hidden: teetime.slots[0].blocked_type === "shotgun",
                            },
                            {
                              icon: "file-import",
                              label: t("Import Players"),
                              onClick: () => void handleOpenImportLeaguePlayers(teetime, teetimeIndex),
                              hidden: teetime.slots[0].blocked_type === "shotgun",
                            },
                            {
                              icon: "copy",
                              label: t("Copy Bookings"),
                              onClick: () => openCopyLeagueBookingsModal(teetime, teetimeIndex),
                              disabled: disableCopyLeagueBookings(teetime, teetimeIndex),
                              hidden: teetime.slots[0].blocked_type === "shotgun",
                            },
                          ],
                        ]}
                      />
                    </div>
                  </div>
                </span>
              </div>
            ) : null}

            {/* TOURNAMENT HEADER */}
            {teetime.slots[0].tournament_id > 0 &&
            (prevTeetime === undefined ||
              prevTeetime.slots[0].tournament_id === null ||
              prevTeetime.slots[0].tournament_id != teetime.slots[0].tournament_id) ? (
              <div className="tee-sheet-events-header pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>
                      <FontAwesomeIcon className="mr-2" icon={faTrophy} />
                      {props?.teeSheetTournaments === undefined ? (
                        <div style={{ display: "inline-flex" }}>
                          <Spin />
                        </div>
                      ) : (
                        tournamentName(teetime.slots[0].tournament_id)
                      )}
                    </div>
                    <div className="text-black">
                      <NavigationDropdownNew
                        showPlainTextLabel
                        rightAlign
                        // type=""
                        label={<FontAwesomeIcon className="th-ellipsis text-white" icon={faEllipsisV} />}
                        sections={[
                          [
                            {
                              icon: "print",
                              label: t("Print Cart Signs"),
                              onClick: () =>
                                props.updateModalState<IPrintCartSignsModal>(
                                  {
                                    isOpen: true,
                                    date: teetime.slots[0].date,
                                    league_id: undefined,
                                    tournament_id: teetime.slots[0].tournament_id,
                                    teetime,
                                    shotgun_application_id: teetime.slots[0].shotgun_application_id,
                                  },
                                  NewTeeSheetTabsDivisionUpdateModalType.PrintCartSigns,
                                ),
                            },
                            {
                              icon: "dollar-sign",
                              label: t("View Account"),
                              onClick: () => navigateToEventAccount("tournament", teetime.slots[0].tournament_id),
                              hidden: !props.teeSheetTournaments?.find(
                                tournament => tournament.id === teetime.slots[0].tournament_id,
                              )?.account_id,
                            },
                            {
                              icon: "pen",
                              label: t("Edit Shotgun"),
                              onClick: () =>
                                props.updateModalState<IEditShotgunPopup>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.EditShotgun,
                                ),
                              hidden: teetime.slots[0].shotgun_application_id === null,
                            },
                            {
                              icon: "trash",
                              label: t("Remove Shotgun"),
                              onClick: () =>
                                props.updateModalState<IRemoveShotgunPopup>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.RemoveShotgun,
                                ),
                              hidden: teetime.slots[0].shotgun_application_id === null,
                            },
                            {
                              icon: "file-export",
                              label: t("Export Shotgun Template"),
                              onClick: () => void handleExportShotgunTemplate(teetime),
                              hidden: teetime.slots[0].blocked_type !== "shotgun",
                            },
                            {
                              icon: "file-import",
                              label: t("Import Draw Sheet"),
                              onClick: () =>
                                props.updateModalState<IFileImportModal>(
                                  { isOpen: true, shotgun_application_id: teetime.slots[0].shotgun_application_id },
                                  NewTeeSheetTabsDivisionUpdateModalType.FileImport,
                                ),
                              hidden: teetime.slots[0].blocked_type !== "shotgun",
                            },
                            {
                              icon: "check",
                              label: t("Check In Participants"),
                              onClick: () =>
                                props.updateModalState<ICheckInAllTournamentParticipantsModal>(
                                  {
                                    isOpen: true,
                                    teetime,
                                  },
                                  NewTeeSheetTabsDivisionUpdateModalType.CheckInAllTournamentParticipants,
                                ),
                            },
                            {
                              icon: "print",
                              label: t("Print Alpha List"),
                              onClick: () => void handlePrintAlphaList(teetime),
                            },
                            {
                              icon: "print",
                              label: t("Print Scorecard"),
                              onClick: () =>
                                props.updateModalState<IPrintScoreCardModal>(
                                  {
                                    isOpen: true,
                                    tournament: props.teeSheetTournaments.find(
                                      tournament => teetime.slots[0].tournament_id === tournament.id,
                                    ),
                                    league: undefined,
                                    teetime,
                                  },
                                  NewTeeSheetTabsDivisionUpdateModalType.PrintScoreCards,
                                ),
                            },

                            // {
                            //   icon: "print",
                            //   label: t("Print"),
                            //   onClick: () => void handlePrintScorecards(teetime),
                            // },
                            {
                              icon: "file-export",
                              label: t("Export Template"),
                              onClick: () => void handleExportTeeTimesTemplate(teetime, teetimeIndex),
                              hidden: teetime.slots[0].blocked_type === "shotgun",
                            },
                            {
                              icon: "file-import",
                              label: t("Import Players"),
                              onClick: () => void handleOpenImportPlayers(teetime, teetimeIndex),
                              hidden: teetime.slots[0].blocked_type === "shotgun",
                            },
                          ],
                        ]}
                      />
                    </div>
                  </div>
                </span>
                <p>
                  {tournamentNote(teetime.slots[0].tournament_id)
                    ? tournamentNote(teetime.slots[0].tournament_id).toLocaleLowerCase()
                    : ""}
                </p>
              </div>
            ) : null}

            {/* Group Bookings Header */}

            {isPartOfGroup(prevTeetime, nextTeetime, teetime) &&
            !teetime.slots[0].tournament_id &&
            !teetime.slots[0].league_id &&
            (prevTeetime === undefined ||
              (prevTeetime?.slots?.every(
                slot =>
                  !slot?.tee_time_bookings_group_id ||
                  teetime?.slots?.every(
                    currTeeTime => currTeeTime?.tee_time_bookings_group_id !== slot?.tee_time_bookings_group_id,
                  ),
              ) &&
                bookingGroupsHeader(nextTeetime, teetime))) ? (
              <div className="tee-sheet-group pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>
                      <FontAwesomeIcon className="mr-2" icon={faUserGroup} />
                      {teetime.slots[0]?.tee_time_bookings_group_name
                        ? teetime.slots[0]?.tee_time_bookings_group_name
                        : t("Group")}
                    </div>
                    <div className="text-black">
                      <NavigationDropdownNew
                        showPlainTextLabel
                        rightAlign
                        label={<FontAwesomeIcon className="th-ellipsis text-white" icon={faEllipsisV} />}
                        sections={[
                          [
                            {
                              icon: "pen-to-square",
                              label: t("Edit Group Name"),
                              onClick: () =>
                                updateEditGroupNameModal({
                                  isOpen: true,
                                  groupId: teetime.slots[0]?.tee_time_bookings_group_id,
                                  groupName: teetime.slots[0]?.tee_time_bookings_group_name ?? "",
                                }),
                            },
                            {
                              icon: "plus",
                              label: t("Add Bookings to Group"),
                              onClick: () => initiateAddToGroup(teetime, teetimeIndex),
                              disabled: disableAddToGroup(teetime, teetimeIndex),
                            },
                            {
                              icon: "ban",
                              label: t("Cancel All Group Bookings"),
                              onClick: () =>
                                updateCancelGroupBookingsModal({
                                  isOpen: true,
                                  groupId: teetime.slots[0]?.tee_time_bookings_group_id,
                                }),
                            },
                          ],
                        ]}
                      />
                    </div>
                  </div>
                </span>
              </div>
            ) : null}

            {/* SHOTGUN HEADER */}
            {teetime.slots[0].blocked_type === "shotgun" &&
            teetime.slots[0].tournament_id === null &&
            teetime.slots[0].league_id === null &&
            (prevTeetime === undefined || prevTeetime.slots[0].blocked_type !== "shotgun") ? (
              <div className="background-primary text-white pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>{t("Shotgun")}</div>
                    <div className="text-black">
                      <NavigationDropdownNew
                        showPlainTextLabel
                        rightAlign
                        label={<FontAwesomeIcon className="th-ellipsis text-white" icon={faEllipsisV} />}
                        sections={[
                          [
                            {
                              icon: "print",
                              label: t("Print Cart Signs"),
                              onClick: () =>
                                props.updateModalState<IPrintCartSignsModal>(
                                  {
                                    isOpen: true,
                                    date: teetime.slots[0].date,
                                    league_id: undefined,
                                    tournament_id: undefined,
                                    teetime,
                                    shotgun_application_id: teetime.slots[0].shotgun_application_id,
                                  },
                                  NewTeeSheetTabsDivisionUpdateModalType.PrintCartSigns,
                                ),
                            },
                            {
                              icon: "pen",
                              label: t("Edit Shotgun"),
                              onClick: () =>
                                props.updateModalState<IEditShotgunPopup>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.EditShotgun,
                                ),
                              hidden: teetime.slots[0].shotgun_application_id === null,
                            },
                            {
                              icon: "trash",
                              label: t("Remove Shotgun"),
                              onClick: () =>
                                props.updateModalState<IRemoveShotgunPopup>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.RemoveShotgun,
                                ),
                              disabled: teetime.slots[0].shotgun_application_id === null,
                            },
                            {
                              icon: "check",
                              label: t("Check In Participants"),
                              onClick: () =>
                                props.updateModalState<ICheckInAllShotGunParticipantsModal>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.CheckInAllShotgunParticipants,
                                ),
                              // hidden: teetime.slots[0].blocked_type !== "shotgun",
                            },
                          ],
                        ]}
                      />
                    </div>
                  </div>
                </span>
              </div>
            ) : null}

            {/* LOTTERY HEADER */}
            {teetime.slots[0].blocked_type === "lottery" &&
            teetime.slots[0].tournament_id === null &&
            teetime.slots[0].league_id === null &&
            (prevTeetime === undefined || prevTeetime?.slots[0]?.lottery_id !== teetime?.slots[0]?.lottery_id) ? (
              <div className="background-primary text-white pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>
                      {props.teeSheetLotteries === undefined ? (
                        <span style={{ display: "inline-flex" }}>
                          <Spin />
                        </span>
                      ) : (
                        <div>
                          <div>
                            <FontAwesomeIcon icon={faCrown} /> {t("Lottery")}
                          </div>
                          <div className="text-xs text-white">{lotteryDates(teetime.slots[0].lottery_id)}</div>
                        </div>
                      )}
                    </div>
                    <div className="text-black">
                      <NavigationDropdownNew
                        showPlainTextLabel
                        rightAlign
                        label={<FontAwesomeIcon className="th-ellipsis text-white" icon={faEllipsisV} />}
                        sections={[
                          [
                            {
                              icon: "eye",
                              label: t("View Requests"),
                              onClick: () => openLotteryRequestsModal(teetime),
                              disabled: !props.teeSheetLotteries || teetime.slots[0].lottery_id === null,
                            },
                            {
                              icon: "pen-to-square",
                              label: t("Edit Lottery"),
                              onClick: () =>
                                props.updateModalState<IEditLotteryModal>(
                                  {
                                    isOpen: true,
                                    lotteryId: teetime?.slots[0]?.lottery_id,
                                    openDate: new Date(
                                      moment(
                                        getLotteryValue(teetime?.slots[0]?.lottery_id, "open_date") as string,
                                      )?.toDate(),
                                    ),
                                    closeDate: new Date(
                                      moment(
                                        getLotteryValue(teetime?.slots[0]?.lottery_id, "close_date") as string,
                                      )?.toDate(),
                                    ),
                                    timePreferences: getLotteryValue(
                                      teetime?.slots[0]?.lottery_id,
                                      "number_of_time_preferences",
                                    ) as 1 | 2 | 3,
                                    allowTimePreferenceWindow: getLotteryValue(
                                      teetime?.slots[0]?.lottery_id,
                                      "allow_time_preference_window",
                                    ) as boolean,
                                    allowGuests: getLotteryValue(
                                      teetime?.slots[0]?.lottery_id,
                                      "allow_guests",
                                    ) as boolean,
                                  },
                                  NewTeeSheetTabsDivisionUpdateModalType.EditLottery,
                                ),
                              disabled: !props.teeSheetLotteries || teetime.slots[0].lottery_id === null,
                            },
                            {
                              icon: "hammer",
                              label: t("Build Lottery"),
                              onClick: () =>
                                props.updateModalState(
                                  {
                                    isOpen: true,
                                    lotteryId: teetime?.slots[0]?.lottery_id,
                                    date: teetime?.slots[0]?.date,
                                  },
                                  NewTeeSheetTabsDivisionUpdateModalType.BuildLottery,
                                ),
                              disabled: !props.teeSheetLotteries || teetime.slots[0].lottery_id === null,
                            },
                            ...(props?.lotteryBuilds?.some(build => build?.lottery_id === teetime?.slots[0]?.lottery_id)
                              ? [
                                  {
                                    icon: "check" as IconName,
                                    label: t("Finalize Lottery"),
                                    onClick: () =>
                                      props.updateModalState(
                                        { isOpen: true, lotteryId: teetime?.slots[0]?.lottery_id },
                                        NewTeeSheetTabsDivisionUpdateModalType.FinalizeLottery,
                                      ),
                                    disabled: !props.teeSheetLotteries || teetime.slots[0].lottery_id === null,
                                  },
                                ]
                              : []),
                          ],
                        ]}
                      />
                    </div>
                  </div>
                </span>
              </div>
            ) : null}

            {/* TEE TIME CONTAINER */}
            <div
              className={classNames("tee-time-new", {
                "pb-3.5 tee-sheet-events-body event-side-border":
                  teetime.slots[0].league_id > 0 ||
                  teetime.slots[0].tournament_id > 0 ||
                  isPartOfGroup(prevTeetime, nextTeetime, teetime),
                "pb-3.5 background-primary-light event-side-border":
                  teetime.slots[0].league_id === null &&
                  teetime.slots[0].tournament_id === null &&
                  (teetime.slots[0].blocked_type === "shotgun" ||
                    ((teetime.slots[0].blocked_type === "lottery" || teetime.slots[0].blocked_type === "crossover") &&
                      teetime.slots[0].lottery_id != null &&
                      lottery?.is_finalized === false)),
                "pt-3.5":
                  (teetime.slots[0].league_id > 0 &&
                    (prevTeetime === undefined ||
                      prevTeetime.slots[0].league_id === null ||
                      prevTeetime.slots[0].league_id != teetime.slots[0].league_id)) ||
                  (teetime.slots[0].tournament_id > 0 &&
                    (prevTeetime === undefined ||
                      prevTeetime.slots[0].tournament_id === null ||
                      prevTeetime.slots[0].tournament_id != teetime.slots[0].tournament_id)) ||
                  (teetime.slots[0].blocked_type === "shotgun" &&
                    (prevTeetime === undefined || prevTeetime.slots[0].blocked_type !== "shotgun")) ||
                  (teetime.slots[0].blocked_type === "lottery" &&
                    (prevTeetime === undefined || prevTeetime.slots[0].lottery_id !== teetime.slots[0].lottery_id)) ||
                  (isFirstTeeTimeInGroup(teetime, teetimeIndex) && isPartOfGroup(prevTeetime, nextTeetime, teetime)),
                "rounded-bottom event-bottom-border":
                  (teetime.slots[0].league_id > 0 &&
                    (nextTeetime === undefined ||
                      nextTeetime.slots[0].league_id === null ||
                      nextTeetime.slots[0].league_id != teetime.slots[0].league_id)) ||
                  (teetime.slots[0].tournament_id > 0 &&
                    (nextTeetime === undefined ||
                      nextTeetime.slots[0].tournament_id === null ||
                      nextTeetime.slots[0].tournament_id != teetime.slots[0].tournament_id)) ||
                  (teetime.slots[0].blocked_type === "shotgun" &&
                    (nextTeetime === undefined || nextTeetime.slots[0].blocked_type !== "shotgun")) ||
                  (!teetime.slots[0].league_id &&
                    !teetime.slots[0].tournament_id &&
                    teetime.slots[0].lottery_id != null &&
                    lottery?.is_finalized === false &&
                    (nextTeetime === undefined || nextTeetime.slots[0].lottery_id !== teetime.slots[0].lottery_id)) ||
                  (isLastTeeTimeInGroup(prevTeetime, nextTeetime, teetime) &&
                    !teetime.slots[0].tournament_id &&
                    !teetime.slots[0].league_id),
                "tee-time-new-spaced":
                  teetime.slots[0].league_id === null &&
                  !isPartOfGroup(prevTeetime, nextTeetime, teetime) &&
                  teetime.slots[0].tournament_id === null &&
                  teetime.slots[0].blocked_type !== "shotgun" &&
                  teetime.slots[0].blocked_type !== "lottery" &&
                  (teetime.slots[0].lottery_id === null || lottery == null || lottery?.is_finalized === true) &&
                  prevTeetime !== undefined,
              })}
              key={teetimeIndex}
              id={String(teetime.slots[0].tee_time_id)}
            >
              {/* SUNRISE MARKER */}
              {((teetimeIndex === 0 && facilityStore.weather?.sunrise < teetime?.start_time) ||
                (facilityStore.weather?.sunrise >= prevTeetime?.start_time &&
                  facilityStore.weather?.sunrise < teetime?.start_time)) && (
                <div className="flex items-center mb-3.5">
                  <div className="sun-time-line"></div>
                  <span className="sun-time-hour">
                    <FontAwesomeIcon icon={faSunrise} className="booking-participant_icon mt-1" />
                    {convertTime(facilityStore.weather?.sunrise)}
                  </span>
                  <div style={{ marginRight: "8px" }} className="sun-time-line"></div>
                </div>
              )}

              {/* HOUR MARKERS */}
              {teetimeIndex === 0 ||
              convertTime(teetime.start_time).split(":")[0] !== convertTime(prevTeetime.start_time).split(":")[0] ? (
                <div className="tee-time hour-block">
                  <p className="tee-time time tee-time hour">
                    {convertTime(teetime.start_time).split(":")[0] +
                      ":00 " +
                      convertTime(teetime.start_time).split(" ")[1]}
                  </p>
                  <div className="tee-time hour-line"></div>
                </div>
              ) : null}

              {/* TEE TIME */}
              <div className="tee-time_container">
                {/* TEE TIME START TIME */}
                <button className="tee-time-time cursor-pointer" onClick={() => {}}>
                  <p
                    className={
                      teetime.slots[0].tournament_id || teetime.slots[0].league_id
                        ? "tee-time-time-text-event"
                        : "tee-time-time-text"
                    }
                  >
                    {teetime.slots[0].blocked_type === "shotgun" ||
                    teetime.slots[0].blocked_type === "shotgun_crossover" ? (
                      <div>
                        <span>
                          {renderPromotionIcon(teetime.slots[0])}
                          <span>{teetime.slots[0].start_hole}</span>
                        </span>
                        {teetime?.slots[0]?.lottery_id &&
                        (teetime?.slots[0]?.league_id || teetime?.slots[0]?.tournament_id) ? (
                          <Badge backgroundColour="#EAECF0" type="gray" size="small">
                            {t("Lottery")}
                          </Badge>
                        ) : null}
                      </div>
                    ) : (
                      <div>
                        <span>
                          {renderPromotionIcon(teetime.slots[0])}
                          <span>{convertTime(teetime.start_time, true)}</span>
                          {!mobileSizedDivision && <span>{convertStartTimePeriod(teetime.start_time)}</span>}
                        </span>
                        {teetime?.slots[0]?.lottery_id &&
                        (teetime?.slots[0]?.league_id || teetime?.slots[0]?.tournament_id) ? (
                          <Badge backgroundColour="#EAECF0" type="gray" size="small">
                            {t("Lottery")}
                          </Badge>
                        ) : null}
                      </div>
                    )}
                  </p>
                </button>

                {/* DIVISION CODE */}
                {!mobileSizedDivision && (
                  <p
                    className="tee-time-division-code"
                    style={calculateDivisionColors(
                      props.allDivisions?.find((division: IDivision) => division.id === teetime.slots[0].division_id)
                        ?.color,
                    )}
                  >
                    {getDivisionCode(teetime.slots[0])}
                  </p>
                )}

                {facilityStore.teeSheetSettings?.validate_power_cart_count &&
                  teetime.power_cart_quantity != null &&
                  teetime.carts_available != null && (
                    <OverlayTrigger
                      placement="right"
                      show={teetime.power_cart_numbers?.length > 0 ? undefined : false}
                      overlay={
                        <Tooltip id={`teeTimePowerCartAvailability-${teetimeIndex}-${teetime.slots[0].division_id}`}>
                          {teetime.power_cart_numbers}
                        </Tooltip>
                      }
                    >
                      <div className="tee-time-power-cart-availability">
                        {`${teetime.power_cart_quantity}/${teetime.carts_available}`}
                      </div>
                    </OverlayTrigger>
                  )}

                {/* SLOTS */}
                <div className="tee-time-slots">
                  <Droppable
                    key={teetime.slots[0].tee_time_id.toString()}
                    droppableId={teetime.slots[0].tee_time_id.toString()}
                    type="LIST"
                    direction="horizontal"
                  >
                    {provided => (
                      <span
                        className="row-container"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        style={
                          {
                            "--tee-time-slot-columns": teetime.slots.length,
                          } as React.CSSProperties
                        }
                      >
                        {teetime?.slots[0]?.lottery_id &&
                        props?.lotteryBuilds?.length > 0 &&
                        getLotteryBuild(teetime?.slots[0]?.tee_time_id)
                          ? //<-------------------------------------------------------------------- Lottery Build slots -------------------------------------------------------------------->
                            getGroupedLotteryBuilds(teetime?.slots[0]?.tee_time_id)?.map(
                              (buildGroup, buildGroupIndex, buildGroups) => {
                                const totalBuildGroupQuantity = getGroupedLotteryBuilds(
                                  teetime?.slots[0]?.tee_time_id,
                                )?.reduce((prev, curr) => prev + curr?.quantity, 0);
                                return (
                                  <div
                                    key={buildGroupIndex}
                                    className={classNames("tee-time-slots_container", {
                                      "tee-time-slots_container-grouped": buildGroup?.quantity > 1,
                                      "tee-time-slots_last":
                                        buildGroupIndex + 1 === buildGroups?.length && totalBuildGroupQuantity >= 4,
                                    })}
                                    style={
                                      {
                                        "--slot-group-span": buildGroup?.quantity,
                                      } as React.CSSProperties
                                    }
                                  >
                                    {[...new Array(buildGroup?.quantity)]?.map((_, buildIndex) => {
                                      const isGuest = getLotteryGuest(buildIndex, buildGroup);
                                      const lotteryBuildFullName = String(
                                        getLotteryBuildValue(buildIndex, buildGroup, "full_name") ?? "",
                                      );
                                      const lotteryBuildNameParts = lotteryBuildFullName.trim().split(/\s+/);
                                      const lotteryBuildFirstName = lotteryBuildNameParts[0] ?? "";
                                      const lotteryBuildLastName = lotteryBuildNameParts.slice(1).join(" ");
                                      return (
                                        <div
                                          className={classNames(
                                            "tee-time-slot",
                                            getTeeTimeSlotWrapJoinClasses(buildIndex, buildGroup?.quantity ?? 0),
                                          )}
                                          key={buildIndex}
                                          onClick={() => openLotteryRequestsModal(teetime)}
                                        >
                                          <RightClickMenu
                                            sections={[
                                              lottery?.is_finalized === false && [
                                                {
                                                  icon: "eye",
                                                  title: t("View Requests"),
                                                  action: () => openLotteryRequestsModal(teetime),
                                                  disabled:
                                                    !props.teeSheetLotteries || teetime.slots[0].lottery_id === null,
                                                },
                                                {
                                                  icon: "pen-to-square",
                                                  title: t("Edit Lottery"),
                                                  action: () =>
                                                    props.updateModalState<IEditLotteryModal>(
                                                      {
                                                        isOpen: true,
                                                        lotteryId: teetime?.slots[0]?.lottery_id,
                                                        openDate: new Date(
                                                          moment(
                                                            getLotteryValue(
                                                              teetime?.slots[0]?.lottery_id,
                                                              "open_date",
                                                            ) as string,
                                                          )?.toDate(),
                                                        ),
                                                        closeDate: new Date(
                                                          moment(
                                                            getLotteryValue(
                                                              teetime?.slots[0]?.lottery_id,
                                                              "close_date",
                                                            ) as string,
                                                          )?.toDate(),
                                                        ),
                                                        timePreferences: getLotteryValue(
                                                          teetime?.slots[0]?.lottery_id,
                                                          "number_of_time_preferences",
                                                        ) as 1 | 2 | 3,
                                                        allowTimePreferenceWindow: getLotteryValue(
                                                          teetime?.slots[0]?.lottery_id,
                                                          "allow_time_preference_window",
                                                        ) as boolean,
                                                        allowGuests: getLotteryValue(
                                                          teetime?.slots[0]?.lottery_id,
                                                          "allow_guests",
                                                        ) as boolean,
                                                      },
                                                      NewTeeSheetTabsDivisionUpdateModalType.EditLottery,
                                                    ),
                                                  disabled:
                                                    !props.teeSheetLotteries || teetime?.slots[0]?.lottery_id === null,
                                                },
                                                {
                                                  icon: "hammer",
                                                  title: t("Build Lottery"),
                                                  action: () =>
                                                    props.updateModalState(
                                                      {
                                                        isOpen: true,
                                                        lotteryId: teetime?.slots[0]?.lottery_id,
                                                        date: teetime?.slots[0]?.date,
                                                      },
                                                      NewTeeSheetTabsDivisionUpdateModalType.BuildLottery,
                                                    ),
                                                  disabled:
                                                    !props.teeSheetLotteries || teetime.slots[0].lottery_id === null,
                                                },
                                                ...(props?.lotteryBuilds?.some(
                                                  build => build?.lottery_id === teetime?.slots[0]?.lottery_id,
                                                )
                                                  ? [
                                                      {
                                                        icon: "check" as IconName,
                                                        title: t("Finalize Lottery"),
                                                        action: () =>
                                                          props.updateModalState(
                                                            { isOpen: true, lotteryId: teetime?.slots[0]?.lottery_id },
                                                            NewTeeSheetTabsDivisionUpdateModalType.FinalizeLottery,
                                                          ),
                                                        disabled:
                                                          !props.teeSheetLotteries ||
                                                          teetime.slots[0].lottery_id === null,
                                                      },
                                                    ]
                                                  : []),
                                              ],
                                            ]}
                                          >
                                            <div className="tee-time-slot_content">
                                              {tabletBookingParticipantLayout ? (
                                                <BookingParticipantTabletLayout
                                                  header={
                                                    <BookingParticipantName
                                                      firstName={lotteryBuildFirstName}
                                                      lastName={lotteryBuildLastName}
                                                      divisionWidth={divisionWidth}
                                                    >
                                                      {isGuest ? (
                                                        <FontAwesomeIcon
                                                          style={{ marginLeft: "0.25rem" }}
                                                          icon={faCircleG}
                                                          size="1x"
                                                        />
                                                      ) : null}
                                                    </BookingParticipantName>
                                                  }
                                                  customerType={
                                                    <div className="booking-participant-customer-type">
                                                      {facilityStore?.teeSheetSettings?.display_customer_type &&
                                                      !isGuest ? (
                                                        <span>
                                                          {getLotteryBuildValue(
                                                            buildIndex,
                                                            buildGroup,
                                                            "customer_type",
                                                          )}
                                                        </span>
                                                      ) : (
                                                        <span className="booking-participant-customer-type-placeholder">
                                                          &nbsp;
                                                        </span>
                                                      )}
                                                    </div>
                                                  }
                                                  meta={null}
                                                  status={
                                                    <FontAwesomeIcon
                                                      icon={faCrown}
                                                      className="booking-participant_icon"
                                                    />
                                                  }
                                                />
                                              ) : (
                                                <div className="tee-time-slot-booking-participant">
                                                  <div className="booking-participant_content">
                                                    {!mobileSizedDivision && (
                                                      <FontAwesomeIcon
                                                        icon={faCrown}
                                                        className="booking-participant_icon"
                                                      />
                                                    )}

                                                    <div>
                                                      <div className="booking-participant-name">
                                                        <span>
                                                          {getLotteryBuildValue(buildIndex, buildGroup, "full_name")}
                                                          {isGuest ? (
                                                            <FontAwesomeIcon
                                                              style={{ marginLeft: "0.5rem" }}
                                                              icon={faCircleG}
                                                              size="1x"
                                                            />
                                                          ) : null}
                                                        </span>
                                                      </div>

                                                      {facilityStore?.teeSheetSettings?.display_customer_type &&
                                                      !isGuest ? (
                                                        <div className="booking-participant-customer-type">
                                                          <span>
                                                            {getLotteryBuildValue(
                                                              buildIndex,
                                                              buildGroup,
                                                              "customer_type",
                                                            )}
                                                          </span>
                                                        </div>
                                                      ) : null}
                                                    </div>
                                                  </div>

                                                  <div className="booking-participant-secondary_content">
                                                    {/* {mobileSizedDivision && (
                                          <div className="booking-participant-holes-small">
                                            {slot.tee_time_bookings_holes}
                                          </div>
                                        )} */}
                                                    <div className="booking-participant-secondary_content-icons">
                                                      {mobileSizedDivision && (
                                                        <FontAwesomeIcon
                                                          icon={faCrown}
                                                          className="booking-participant_icon"
                                                        />
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </RightClickMenu>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              },
                            )
                          : //<-------------------------------------------------------------------- Lottery Build slots -------------------------------------------------------------------->
                            null}
                        {findMatchingGroupedTeeTime(
                          teetime,
                          props.groupedTeeTimes,
                          getGroupedLotteryBuilds(teetime?.slots[0]?.tee_time_id)?.reduce(
                            (prev, curr) => prev + curr?.quantity,
                            0,
                          ),
                        )?.slots?.map((slotGroup, groupIndex: number, slotGroups) => {
                          const slotId = slotGroup[0]?.tee_time_slot_id.toString();

                          return (
                            <Draggable
                              key={slotId}
                              draggableId={slotId}
                              isDragDisabled={
                                (mobileSizedDivision && windowSize?.width <= TABLET_WIDTH) ||
                                slotGroup.some(
                                  slot =>
                                    slot.tee_time_booking_id == null ||
                                    slot.blocked_type === "crossover" ||
                                    slot.check_in_status === "checked" ||
                                    teetimeLoading,
                                )
                              }
                              index={groupIndex}
                            >
                              {provided => (
                                <div
                                  className={classNames("tee-time-slots_container", {
                                    "tee-time-slots_container-grouped": slotGroup.length > 1,
                                    "tee-time-slots_last": teetime.slots.length === groupIndex + 1,
                                  })}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={
                                    {
                                      ...provided.draggableProps.style,
                                      "--slot-group-span": slotGroup.length,
                                    } as unknown
                                  }
                                >
                                  {slotGroup.map(
                                    (slot, slotIndex: number) => {
                                      // BOOKED SLOT
                                      if (slot.customer_id) {
                                        return (
                                          <div
                                            key={slotIndex}
                                            className={classNames("tee-time-slot", {
                                              ...getTeeTimeSlotWrapJoinClasses(slotIndex, slotGroup.length),
                                              "tee-time-slot_checked": slot.check_in_status === "checked",
                                              "tee-time-slot_crossover": slot.blocked_type === "crossover",
                                              "tee-time-slot_blocked": slot.blocked_type === "blocked",
                                              "tee-time-slot_arrived": slot.check_in_status === "arrived",
                                              "tee-time-slot_no-show": slot.no_show_type !== null,
                                              "tee-time-slot_turn": slot.turn,
                                              "tee-time-slot_no-show-weather": slot.no_show_type === "weather",
                                              "tee-time-slot_booking_engine":
                                                slot.tee_time_bookings_source === "booking_engine",
                                              "tee-time-slot_has_notes": slot.has_notes,
                                              "tee-time-slot_customer-type-display":
                                                facilityStore?.teeSheetSettings?.display_customer_type,
                                              "tee-time-slot_loading": teetimeLoading,
                                              "tee-time-slot-highlight":
                                                facilityStore.teeSheetSettings.highlight_new_bookings &&
                                                moment
                                                  .utc(slot.tee_time_bookings_completed_at)
                                                  .local()
                                                  .isSameOrAfter(
                                                    moment().subtract({
                                                      hours:
                                                        facilityStore?.teeSheetSettings.highlight_new_bookings_window,
                                                    }),
                                                  ) &&
                                                moment
                                                  .utc(slot.tee_time_bookings_completed_at)
                                                  .local()
                                                  .isSameOrBefore(moment()) &&
                                                slot.check_in_status === "unchecked",
                                            })}
                                            style={{ backgroundColor: findCustomerTypeBackground(slot) }}
                                            onClick={() => {
                                              if (!teetimeLoading) {
                                                handleNavigateToBookingDetails(slot.tee_time_id, slot);
                                              }
                                            }}
                                          >
                                            <RightClickMenu
                                              disableAllActions={teetimeLoading}
                                              alignment={
                                                props.teeSheetView !== "side-by-side" ||
                                                groupIndex < slotGroups.length - 1 ||
                                                slotGroup.length === 4
                                                  ? "left"
                                                  : "right"
                                              }
                                              informationSection={[
                                                `${t("Booked on")} ${moment
                                                  .utc(slot.tee_time_bookings_completed_at)
                                                  .local()
                                                  .format("lll")}`,
                                                ...(slot.no_show_type
                                                  ? [
                                                      <Badge key="no_show_badge" size="xsmall" colour="#FDB022" outline>
                                                        {slot.no_show_type === "defer"
                                                          ? t("Defer Charge")
                                                          : valueToString(slot.no_show_type)}
                                                      </Badge>,
                                                    ]
                                                  : []),
                                                <hr
                                                  key="pace_tracker_divider"
                                                  className="right-click-menu-section-divider"
                                                />,
                                                <PaceTrackerContextInfo
                                                  key="pace_tracker_info"
                                                  slots={teetime.slots}
                                                />,
                                              ]}
                                              sections={[
                                                [
                                                  {
                                                    icon: "pencil",
                                                    title: t("Edit Booking"),
                                                    action: () =>
                                                      void props.handleEditBooking(teetime, slot.tee_time_booking_id),
                                                  },
                                                  {
                                                    icon: "copy",
                                                    title: t("Duplicate Booking"),
                                                    action: () =>
                                                      initiateDuplicateBooking(
                                                        slot.tee_time_booking_id,
                                                        slot.tee_time_id,
                                                      ),
                                                  },
                                                  {
                                                    icon: "ban",
                                                    title: t("Cancel Booking"),
                                                    action: () => {
                                                      const teetimeToCancelDate = moment(slot.date).format(
                                                        "MMMM Do, YYYY",
                                                      );
                                                      const teetimeToCancelTime = convertTime(teetime.start_time);

                                                      props.updateModalState<ICancelBookingPopup>(
                                                        {
                                                          isOpen: true,
                                                          teetimeToCancelDate,
                                                          teetimeToCancelTime,
                                                          teetimeToCancelBookingId: slot.tee_time_booking_id,
                                                        },
                                                        NewTeeSheetTabsDivisionUpdateModalType.CancelBooking,
                                                      );
                                                    },
                                                    disabled: checkForCheckedInPlayer(slotGroup),
                                                  },
                                                  {
                                                    icon: "circle-check",
                                                    title: t("Check In Player"),
                                                    action: () => {
                                                      props.updateModalState<ICheckInPlayerPopup>(
                                                        {
                                                          isOpen: true,
                                                          bookingParticipantName: `${slot.customer_first_name} ${slot.customer_last_name}`,
                                                          bookingParticipantId: slot.booking_participant_id,
                                                          isGuest: slot.guest,
                                                        },
                                                        NewTeeSheetTabsDivisionUpdateModalType.CheckInPlayer,
                                                      );
                                                    },
                                                    disabled: slot.check_in_status === "checked",
                                                  },
                                                  {
                                                    icon: "user-slash",
                                                    title: t("Cancel Player"),
                                                    action: () => {
                                                      props.updateModalState<ICancelPlayerPopup>(
                                                        {
                                                          isOpen: true,
                                                          bookingParticipantName: `${slot.customer_first_name} ${slot.customer_last_name}`,
                                                          bookingParticipantId: slot.booking_participant_id,
                                                        },
                                                        NewTeeSheetTabsDivisionUpdateModalType.CancelPlayer,
                                                      );
                                                    },
                                                    disabled: slot.check_in_status !== "unchecked",
                                                  },
                                                  {
                                                    icon: "cancel",
                                                    title: t("No Show"),
                                                    action: () => {
                                                      props.updateModalState<INoShowModal>(
                                                        {
                                                          isOpen: true,
                                                          bookingParticipantIds: [slot.booking_participant_id],
                                                          slotGroup: slotGroup,
                                                          bookingId: slot?.tee_time_booking_id,
                                                          teeTimeIndex: teetimeIndex,
                                                        },
                                                        NewTeeSheetTabsDivisionUpdateModalType.NoShow,
                                                      );
                                                    },
                                                    disabled: slot.tee_time_booking_participant_status === "no_show",
                                                  },
                                                  {
                                                    icon: "umbrella",
                                                    title: t("secure.facility.tee_sheet.tee_sheet_booking_details.043"),
                                                    action: () => {
                                                      props.updateModalState<IIssueRainCheckModal>(
                                                        {
                                                          isOpen: true,
                                                          bookingId: slot.tee_time_booking_id,
                                                          bookingParticipantId: slot.booking_participant_id,
                                                          holes: slot.tee_time_bookings_holes,
                                                        },
                                                        NewTeeSheetTabsDivisionUpdateModalType.IssueRainCheck,
                                                      );
                                                    },
                                                    disabled:
                                                      slot.check_in_status !== "checked" ||
                                                      slot.order_financial_status !== "paid",
                                                  },
                                                  {
                                                    icon: "cars",
                                                    title: t("secure.facility.tee_sheet.tee_sheet_booking_details.225"),
                                                    action: () =>
                                                      props.updateModalState<IPowerCartNumbersModal>(
                                                        { isOpen: true, teetime },
                                                        NewTeeSheetTabsDivisionUpdateModalType.PowerCartNumbers,
                                                      ),
                                                  },
                                                  {
                                                    icon: "print",
                                                    title: t("secure.facility.tee_sheet.tee_sheet_booking_display.008"),
                                                    action: () => {
                                                      void loadCartWaiver(slot.customer_id, slot.tee_time_id);
                                                    },
                                                  },
                                                  {
                                                    icon: "list",
                                                    title: t("Booking Audit Trail"),
                                                    action: () =>
                                                      props.updateModalState<IAuditTrailModal>(
                                                        {
                                                          isOpen: true,
                                                          teetime,
                                                          type: "booking",
                                                          bookingId: slot.tee_time_booking_id,
                                                        },
                                                        NewTeeSheetTabsDivisionUpdateModalType.AuditTrail,
                                                      ),
                                                  },
                                                ],
                                                [
                                                  ...(slot.shotgun_application_id
                                                    ? [
                                                        {
                                                          icon: "golf-ball-tee" as IconName,
                                                          title: t("Edit Start Hole"),
                                                          action: () =>
                                                            props.updateModalState<IEditStartHoleModal>(
                                                              {
                                                                isOpen: true,
                                                                teetime,
                                                                start_hole: teetime.slots[0].start_hole,
                                                              },
                                                              NewTeeSheetTabsDivisionUpdateModalType.EditStartHole,
                                                            ),
                                                        },
                                                      ]
                                                    : []),
                                                  {
                                                    icon: "circle-info",
                                                    title: t("Tee Time Details"),
                                                    action: () =>
                                                      props.updateModalState<ITeeTimeDetailsModal>(
                                                        { isOpen: true, teetime },
                                                        NewTeeSheetTabsDivisionUpdateModalType.TeeTimeDetails,
                                                      ),
                                                  },
                                                  {
                                                    icon: "list",
                                                    title: t("Tee Time Audit Trail"),
                                                    action: () =>
                                                      props.updateModalState<IAuditTrailModal>(
                                                        {
                                                          isOpen: true,
                                                          teetime,
                                                          type: "teeTime",
                                                        },
                                                        NewTeeSheetTabsDivisionUpdateModalType.AuditTrail,
                                                      ),
                                                  },
                                                  {
                                                    icon: "flag",
                                                    title: t("Create Shotgun"),
                                                    action: () =>
                                                      props.updateModalState<ICreateShotgunModal>(
                                                        { isOpen: true, teetime },
                                                        NewTeeSheetTabsDivisionUpdateModalType.CreateShotgun,
                                                      ),
                                                  },
                                                  {
                                                    icon: "distribute-spacing-vertical",
                                                    title: slot.shotgun_application_id
                                                      ? t("Add Group")
                                                      : t("Add Squeeze Time"),
                                                    action: () =>
                                                      slot.shotgun_application_id
                                                        ? props.updateModalState<IAddTeeTimeModal>(
                                                            { isOpen: true, teetime },
                                                            NewTeeSheetTabsDivisionUpdateModalType.AddTeeTime,
                                                          )
                                                        : props.updateModalState<IAddSqueezeTimeModal>(
                                                            { isOpen: true, teetime },
                                                            NewTeeSheetTabsDivisionUpdateModalType.AddSqueezeTime,
                                                          ),
                                                  },
                                                ],
                                              ]}
                                            >
                                              <div className="tee-time-slot_content">
                                                {tabletBookingParticipantLayout ? (
                                                  <BookingParticipantTabletLayout
                                                    header={
                                                      <BookingParticipantName
                                                        firstName={slot.customer_first_name}
                                                        lastName={slot.customer_last_name}
                                                        divisionWidth={divisionWidth}
                                                      >
                                                        {slot.guest ? (
                                                          <FontAwesomeIcon
                                                            style={{ marginLeft: "0.25rem" }}
                                                            icon={faCircleG}
                                                            size="1x"
                                                          />
                                                        ) : null}
                                                        {slot.has_high_priority_notes && !slot.guest ? (
                                                          <OverlayTrigger
                                                            placement="bottom"
                                                            overlay={
                                                              <Tooltip id={`booking-note-${slot.tee_time_booking_id}`}>
                                                                {renderBookingNoteTooltip(highPriorityNotes)}
                                                              </Tooltip>
                                                            }
                                                            key={slot.tee_time_slot_id}
                                                            onEnter={() =>
                                                              void handleLoadHighPriorityNotes(slot.customer_id)
                                                            }
                                                          >
                                                            <FontAwesomeIcon
                                                              style={{ marginLeft: "0.25rem" }}
                                                              icon={faExclamationCircle}
                                                              size="1x"
                                                              className="text-error"
                                                            />
                                                          </OverlayTrigger>
                                                        ) : null}
                                                        {slot.restricted ? (
                                                          <FontAwesomeIcon
                                                            style={{ marginLeft: "0.25rem" }}
                                                            icon={faTriangleExclamation}
                                                            size="1x"
                                                            className="text-warning"
                                                          />
                                                        ) : null}
                                                      </BookingParticipantName>
                                                    }
                                                    customerType={
                                                      <div className="booking-participant-customer-type">
                                                        {facilityStore?.teeSheetSettings?.display_customer_type &&
                                                        !slot.guest ? (
                                                          <>
                                                            <span>{slot.customer_type_title}</span>
                                                            {slot.customer_type_subtitle ? (
                                                              <span>{` - ${slot.customer_type_subtitle}`}</span>
                                                            ) : null}
                                                          </>
                                                        ) : (
                                                          <span className="booking-participant-customer-type-placeholder">
                                                            &nbsp;
                                                          </span>
                                                        )}
                                                      </div>
                                                    }
                                                    bookingSource={
                                                      <BookingSourceLogo
                                                        source={slot.tee_time_bookings_source}
                                                        withBackground
                                                      />
                                                    }
                                                    meta={
                                                      <>
                                                        <span className="booking-participant-holes-tablet">
                                                          {convertHoles(
                                                            slot.tee_time_bookings_holes,
                                                            facilityStore.facility?.courses?.find(
                                                              course => course.id === slot.course_id,
                                                            ),
                                                          )}
                                                        </span>
                                                        <span className="booking-participant_tablet-equipment">
                                                          {slot.riding ? (
                                                            <span className="booking-participant_icon booking-participant_icon--inline">
                                                              <CustomIcon
                                                                src="../../../public/images/powercart2-01.svg"
                                                                size="small"
                                                              />
                                                              {slot.inventory_power_cart_number ||
                                                              slot.power_cart_number ? (
                                                                <span className="booking-participant_icon-label">
                                                                  {slot.inventory_power_cart_number ??
                                                                    slot.power_cart_number}
                                                                </span>
                                                              ) : null}
                                                            </span>
                                                          ) : (
                                                            <FontAwesomeIcon
                                                              icon={faPersonWalking}
                                                              className="booking-participant_icon"
                                                            />
                                                          )}
                                                          {slot.bag_number !== null && !slot.guest ? (
                                                            <span className="booking-participant_icon booking-participant_icon--inline">
                                                              <CustomIcon
                                                                src="../../../public/images/golf-bag.svg"
                                                                size="small"
                                                              />
                                                              <span className="booking-participant_icon-label">
                                                                {slot.bag_number}
                                                              </span>
                                                            </span>
                                                          ) : null}
                                                        </span>
                                                      </>
                                                    }
                                                    status={
                                                      <>
                                                        <BookingSourceIcon source={slot.tee_time_bookings_source} />
                                                        {showTabletBookingNoteIcon &&
                                                        (slot.has_notes ||
                                                          (slot.tee_time_bookings_has_notes && !slot.guest)) ? (
                                                          <OverlayTrigger
                                                            placement="bottom"
                                                            overlay={
                                                              <Tooltip
                                                                id={`booking-note-${slot.booking_participant_id}`}
                                                              >
                                                                {renderBookingNoteTooltip(bookingNotes)}
                                                              </Tooltip>
                                                            }
                                                            key={slot.booking_participant_id}
                                                            onEnter={() =>
                                                              void handleLoadBookingNotes(
                                                                slot.tee_time_booking_id,
                                                                slot.booking_participant_id,
                                                              )
                                                            }
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={faStickyNote}
                                                              className="booking-participant_icon"
                                                            />
                                                          </OverlayTrigger>
                                                        ) : null}
                                                        {renderBookingParticipantIcons(slot, {
                                                          includeHoles: false,
                                                          hideCheckInStatusIcons: compactTabletSizedDivision,
                                                        })}
                                                      </>
                                                    }
                                                  />
                                                ) : (
                                                  <div className="tee-time-slot-booking-participant">
                                                    <div className="booking-participant_content">
                                                      {!mobileSizedDivision && renderBookingParticipantIcons(slot)}

                                                      <div>
                                                        <BookingParticipantName
                                                          firstName={slot.customer_first_name}
                                                          lastName={slot.customer_last_name}
                                                          divisionWidth={divisionWidth}
                                                        >
                                                          {slot.guest ? (
                                                            <FontAwesomeIcon
                                                              style={{ marginLeft: "0.5rem" }}
                                                              icon={faCircleG}
                                                              size="1x"
                                                            />
                                                          ) : null}
                                                          {!mobileSizedDivision &&
                                                          slot.has_high_priority_notes &&
                                                          !slot.guest ? (
                                                            <OverlayTrigger
                                                              placement="bottom"
                                                              overlay={
                                                                <Tooltip
                                                                  id={`booking-note-${slot.tee_time_booking_id}`}
                                                                >
                                                                  {renderBookingNoteTooltip(highPriorityNotes)}
                                                                </Tooltip>
                                                              }
                                                              key={slot.tee_time_slot_id}
                                                              onEnter={() =>
                                                                void handleLoadHighPriorityNotes(slot.customer_id)
                                                              }
                                                            >
                                                              <FontAwesomeIcon
                                                                style={{ marginLeft: "0.5rem" }}
                                                                icon={faExclamationCircle}
                                                                size="1x"
                                                                className="text-error"
                                                              />
                                                            </OverlayTrigger>
                                                          ) : null}
                                                          {slot.restricted ? (
                                                            <FontAwesomeIcon
                                                              style={{ marginLeft: "0.5rem" }}
                                                              icon={faTriangleExclamation}
                                                              size="1x"
                                                              className="text-warning"
                                                            />
                                                          ) : null}
                                                        </BookingParticipantName>

                                                        {facilityStore?.teeSheetSettings?.display_customer_type &&
                                                        !slot.guest ? (
                                                          <div className="booking-participant-customer-type">
                                                            <span>{slot.customer_type_title}</span>
                                                            {slot.customer_type_subtitle ? (
                                                              <span>{` - ${slot.customer_type_subtitle}`}</span>
                                                            ) : null}
                                                          </div>
                                                        ) : null}
                                                      </div>
                                                    </div>

                                                    <div className="booking-participant-secondary_content">
                                                      {mobileSizedDivision && (
                                                        <div className="booking-participant-holes-small">
                                                          {convertHoles(
                                                            slot.tee_time_bookings_holes,
                                                            facilityStore.facility?.courses?.find(
                                                              course => course.id === slot.course_id,
                                                            ),
                                                          )}
                                                        </div>
                                                      )}
                                                      <div className="booking-participant-secondary_content-icons">
                                                        {mobileSizedDivision && renderBookingParticipantIcons(slot)}

                                                        <BookingSourceIcon source={slot.tee_time_bookings_source} />

                                                        <BookingSourceLogo
                                                          source={slot.tee_time_bookings_source}
                                                          withBackground
                                                        />

                                                        {!mobileSizedDivision &&
                                                        (slot.has_notes ||
                                                          (slot.tee_time_bookings_has_notes && !slot.guest)) ? (
                                                          <OverlayTrigger
                                                            placement="bottom"
                                                            overlay={
                                                              <Tooltip
                                                                id={`booking-note-${slot.booking_participant_id}`}
                                                              >
                                                                {renderBookingNoteTooltip(bookingNotes)}
                                                              </Tooltip>
                                                            }
                                                            key={slot.booking_participant_id}
                                                            onEnter={() =>
                                                              void handleLoadBookingNotes(
                                                                slot.tee_time_booking_id,
                                                                slot.booking_participant_id,
                                                              )
                                                            }
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={faStickyNote}
                                                              className="booking-participant_icon"
                                                            />
                                                          </OverlayTrigger>
                                                        ) : null}

                                                        {slot.riding ? (
                                                          <div className="booking-participant_icon flex flex-col items-center">
                                                            <CustomIcon
                                                              src="../../../public/images/powercart2-01.svg"
                                                              size="small"
                                                            />
                                                            {!mobileSizedDivision &&
                                                            (slot.inventory_power_cart_number ||
                                                              slot.power_cart_number) ? (
                                                              <div className="text-xs">
                                                                {slot.inventory_power_cart_number ??
                                                                  slot.power_cart_number}
                                                              </div>
                                                            ) : null}
                                                          </div>
                                                        ) : (
                                                          <FontAwesomeIcon
                                                            icon={faPersonWalking}
                                                            className="booking-participant_icon"
                                                          />
                                                        )}

                                                        {slot.bag_number !== null && !slot.guest && (
                                                          <div className="booking-participant_icon flex flex-col items-center">
                                                            <CustomIcon
                                                              src="../../../public/images/golf-bag.svg"
                                                              size="small"
                                                            />
                                                            {!mobileSizedDivision ? (
                                                              <div className="text-xs">{slot.bag_number}</div>
                                                            ) : null}
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </RightClickMenu>
                                          </div>
                                        );
                                      } else {
                                        // UNBOOKED TEE TIME
                                        return (
                                          <div
                                            key={slotIndex}
                                            className={classNames("tee-time-slot", {
                                              "tee-time-slot_crossover":
                                                slot.blocked_type === "crossover" ||
                                                slot.blocked_type === "shotgun_crossover",
                                              "tee-time-slot_blocked":
                                                slot.blocked_type === "blocked" ||
                                                slot.blocked_type === "shotgun_blocked" ||
                                                slot.blocked_type === "shotgun_disabled",
                                              "tee-time-slot_no-show":
                                                slot.no_show_type && slot.no_show_type !== "weather",
                                              "tee-time-slot_no-show-weather": slot.no_show_type === "weather",
                                              "tee-time-slot_customer-type-display":
                                                facilityStore?.teeSheetSettings?.display_customer_type,
                                              "tee-time-slot_loading": teetimeLoading,
                                            })}
                                            onClick={() => {
                                              if (!teetimeLoading) {
                                                if (
                                                  teetime.slots[0].blocked_type === "shotgun_blocked" ||
                                                  teetime.slots[0].blocked_type === "blocked"
                                                ) {
                                                  props.updateMainState({ selectedTeeTime: teetime });
                                                  props.updateModalState(
                                                    { isOpen: true },
                                                    NewTeeSheetTabsDivisionUpdateModalType.BlockedTeeTime,
                                                  );
                                                } else if (
                                                  teetime?.slots[0]?.lottery_id &&
                                                  teetime?.slots[0]?.blocked_type === "lottery"
                                                ) {
                                                  void props?.handleInitiateLottery(teetime, slot);
                                                } else {
                                                  void props.handleInitiateBooking(teetime, slot);
                                                }
                                              }
                                            }}
                                          >
                                            <TeeTimeToolTip
                                              prepaidRequired={false}
                                              cardRequired={false}
                                              parentId={slot.tee_time_slot_id}
                                              onMouseEnter={token => handleMouseEnter(teetime, token)}
                                              disable={props.dragAndDropState.teetimeToolTipDisabled}
                                            >
                                              <RightClickMenu
                                                disableAllActions={teetimeLoading}
                                                alignment={
                                                  props.teeSheetView !== "side-by-side" ||
                                                  groupIndex < slotGroups.length - 1
                                                    ? "left"
                                                    : "right"
                                                }
                                                sections={[
                                                  ...(slot.blocked_type === "blocked" || slot.blocked_type === "open"
                                                    ? [
                                                        [
                                                          slot.blocked_type === "blocked"
                                                            ? {
                                                                icon: "circle" as IconName,
                                                                title: t("Mark as Open"),
                                                                action: () =>
                                                                  void setBlockedType(slot.tee_time_id, "open"),
                                                              }
                                                            : {
                                                                icon: "ban" as IconName,
                                                                title: t("Mark as Blocked"),
                                                                action: () =>
                                                                  void setBlockedType(slot.tee_time_id, "blocked"),
                                                              },
                                                        ],
                                                      ]
                                                    : []),
                                                  [
                                                    ...(slot.shotgun_application_id
                                                      ? [
                                                          {
                                                            icon: "golf-ball-tee" as IconName,
                                                            title: t("Edit Start Hole"),
                                                            action: () =>
                                                              props.updateModalState<IEditStartHoleModal>(
                                                                {
                                                                  isOpen: true,
                                                                  teetime,
                                                                  start_hole: teetime.slots[0].start_hole,
                                                                },
                                                                NewTeeSheetTabsDivisionUpdateModalType.EditStartHole,
                                                              ),
                                                          },
                                                        ]
                                                      : []),
                                                    {
                                                      icon: "circle-info",
                                                      title: t("Tee Time Details"),
                                                      action: () =>
                                                        props.updateModalState<ITeeTimeDetailsModal>(
                                                          { isOpen: true, teetime },
                                                          NewTeeSheetTabsDivisionUpdateModalType.TeeTimeDetails,
                                                        ),
                                                    },
                                                    {
                                                      icon: "list",
                                                      title: t("Tee Time Audit Trail"),
                                                      action: () =>
                                                        props.updateModalState<IAuditTrailModal>(
                                                          {
                                                            isOpen: true,
                                                            teetime,
                                                            type: "teeTime",
                                                          },
                                                          NewTeeSheetTabsDivisionUpdateModalType.AuditTrail,
                                                        ),
                                                    },
                                                    {
                                                      icon: "user",
                                                      title: t("Add Player"),
                                                      action: () => void handleOpenAddPlayer(slot),
                                                    },
                                                    {
                                                      icon: "flag",
                                                      title: t("Create Shotgun"),
                                                      action: () =>
                                                        props.updateModalState<ICreateShotgunModal>(
                                                          { isOpen: true, teetime },
                                                          NewTeeSheetTabsDivisionUpdateModalType.CreateShotgun,
                                                        ),
                                                    },
                                                    {
                                                      icon: "distribute-spacing-vertical",
                                                      title: slot.shotgun_application_id
                                                        ? t("Add Group")
                                                        : t("Add Squeeze Time"),
                                                      action: () =>
                                                        slot.shotgun_application_id
                                                          ? props.updateModalState<IAddTeeTimeModal>(
                                                              { isOpen: true, teetime },
                                                              NewTeeSheetTabsDivisionUpdateModalType.AddTeeTime,
                                                            )
                                                          : props.updateModalState<IAddSqueezeTimeModal>(
                                                              { isOpen: true, teetime },
                                                              NewTeeSheetTabsDivisionUpdateModalType.AddSqueezeTime,
                                                            ),
                                                    },
                                                    ...(slot.blocked_type === "shotgun"
                                                      ? [
                                                          {
                                                            icon: "ban" as IconName,
                                                            title: t("Remove Group"),
                                                            action: () =>
                                                              props.updateModalState<IRemoveTeeTimePopup>(
                                                                { isOpen: true, teetime },
                                                                NewTeeSheetTabsDivisionUpdateModalType.RemoveTeeTime,
                                                              ),
                                                            disabled: slot.quantity_remaining !== 4,
                                                          },
                                                        ]
                                                      : []),
                                                    {
                                                      icon: "print",
                                                      title: t("Print Cart Signs"),
                                                      action: () =>
                                                        props.updateModalState<IPrintCartSignsModal>(
                                                          {
                                                            isOpen: true,
                                                            date: teetime.slots[0].date,
                                                            tournament_id: undefined,
                                                            league_id: undefined,
                                                            shotgun_application_id: undefined,
                                                            teetime,
                                                            teetime_id: teetime?.slots[0]?.tee_time_id,
                                                          },
                                                          NewTeeSheetTabsDivisionUpdateModalType.PrintCartSigns,
                                                        ),
                                                    },
                                                  ],
                                                  [
                                                    ...(slot?.lottery_id && lottery?.is_finalized === false
                                                      ? [
                                                          {
                                                            icon: "eye" as IconName,
                                                            title: t("View Requests"),
                                                            action: () => openLotteryRequestsModal(teetime),
                                                            disabled:
                                                              !props.teeSheetLotteries ||
                                                              teetime.slots[0].lottery_id === null,
                                                          },
                                                          {
                                                            icon: "pen-to-square" as IconName,
                                                            title: t("Edit Lottery"),
                                                            action: () =>
                                                              props.updateModalState<IEditLotteryModal>(
                                                                {
                                                                  isOpen: true,
                                                                  lotteryId: slot?.lottery_id,
                                                                  openDate: new Date(
                                                                    moment(
                                                                      getLotteryValue(
                                                                        slot?.lottery_id,
                                                                        "open_date",
                                                                      ) as string,
                                                                    )?.toDate(),
                                                                  ),
                                                                  closeDate: new Date(
                                                                    moment(
                                                                      getLotteryValue(
                                                                        slot?.lottery_id,
                                                                        "close_date",
                                                                      ) as string,
                                                                    )?.toDate(),
                                                                  ),
                                                                  timePreferences: getLotteryValue(
                                                                    slot?.lottery_id,
                                                                    "number_of_time_preferences",
                                                                  ) as 1 | 2 | 3,
                                                                  allowTimePreferenceWindow: getLotteryValue(
                                                                    slot?.lottery_id,
                                                                    "allow_time_preference_window",
                                                                  ) as boolean,
                                                                  allowGuests: getLotteryValue(
                                                                    slot?.lottery_id,
                                                                    "allow_guests",
                                                                  ) as boolean,
                                                                },
                                                                NewTeeSheetTabsDivisionUpdateModalType.EditLottery,
                                                              ),
                                                            disabled:
                                                              !props.teeSheetLotteries || slot?.lottery_id === null,
                                                          },
                                                          {
                                                            icon: "hammer" as IconName,
                                                            title: t("Build Lottery"),
                                                            action: () =>
                                                              props.updateModalState(
                                                                {
                                                                  isOpen: true,
                                                                  lotteryId: slot?.lottery_id,
                                                                  date: slot?.date,
                                                                },
                                                                NewTeeSheetTabsDivisionUpdateModalType.BuildLottery,
                                                              ),
                                                            disabled:
                                                              !props.teeSheetLotteries ||
                                                              teetime.slots[0].lottery_id === null,
                                                          },
                                                        ]
                                                      : [
                                                          {
                                                            icon: "tickets" as IconName,
                                                            title: t("Create Lottery"),
                                                            action: () =>
                                                              props.updateModalState<ILotteryModal>(
                                                                {
                                                                  isOpen: true,
                                                                  courseId: slot?.course_id,
                                                                  date: slot?.date,
                                                                  openDate: new Date(moment(slot?.date).toDate()),
                                                                  closeDate: new Date(moment(slot?.date).toDate()),
                                                                  startTime: slot?.start_time,
                                                                  endTime: slot?.start_time,
                                                                  timePreferences: 1,
                                                                  allowTimePreferenceWindow: false,
                                                                  allowGuests: true,
                                                                },
                                                                NewTeeSheetTabsDivisionUpdateModalType.Lottery,
                                                              ),
                                                            disabled: slot?.blocked_type === "lottery",
                                                          },
                                                        ]),
                                                  ],
                                                ]}
                                              >
                                                <div
                                                  className={classNames("tee-time-slot_content", {
                                                    "tee-time-slot_content--tablet-empty":
                                                      tabletBookingParticipantLayout,
                                                  })}
                                                >
                                                  {tabletBookingParticipantLayout ? (
                                                    <>
                                                      {slot.blocked_type !== null && slot.blocked_type !== "open" ? (
                                                        <>
                                                          {slot.blocked_type === "lottery" ? (
                                                            <FontAwesomeIcon
                                                              icon={faCrown}
                                                              className="booking-participant_icon"
                                                            />
                                                          ) : slot.blocked_type === "shotgun_disabled" ? (
                                                            <em>{t("Blocked for shotgun")}</em>
                                                          ) : (
                                                            <FontAwesomeIcon
                                                              icon={
                                                                slot.blocked_type === "crossover" ||
                                                                slot.blocked_type === "shotgun_crossover"
                                                                  ? faRepeatAlt
                                                                  : faBan
                                                              }
                                                              className="booking-participant_icon"
                                                            />
                                                          )}
                                                        </>
                                                      ) : (
                                                        <FontAwesomeIcon
                                                          icon={faPlusCircle}
                                                          className="booking-participant_icon"
                                                        />
                                                      )}
                                                    </>
                                                  ) : slot.blocked_type !== null && slot.blocked_type !== "open" ? (
                                                    <div className="">
                                                      {slot.blocked_type === "blocked" && (
                                                        <p className="text-center">
                                                          <FontAwesomeIcon
                                                            icon={faBan}
                                                            className="booking-participant_icon"
                                                          />
                                                        </p>
                                                      )}

                                                      {slot.blocked_type === "crossover" && (
                                                        <p className="text-center">
                                                          <FontAwesomeIcon
                                                            icon={faRepeatAlt}
                                                            className="booking-participant_icon"
                                                          />
                                                        </p>
                                                      )}

                                                      {slot.blocked_type === "shotgun" && (
                                                        <p className="text-center">
                                                          <FontAwesomeIcon
                                                            icon={faPlusCircle}
                                                            className="booking-participant_icon"
                                                          />
                                                        </p>
                                                      )}

                                                      {slot.blocked_type === "shotgun_blocked" && (
                                                        <p className="text-center">
                                                          <FontAwesomeIcon
                                                            icon={faBan}
                                                            className="booking-participant_icon"
                                                          />
                                                        </p>
                                                      )}

                                                      {slot?.blocked_type === "lottery" && (
                                                        <p className="text-center">
                                                          <FontAwesomeIcon
                                                            icon={faCrown}
                                                            className="booking-participant_icon"
                                                          />
                                                        </p>
                                                      )}

                                                      {slot.blocked_type === "shotgun_disabled" && (
                                                        <p className="text-center">
                                                          <em>{t("Blocked for shotgun")}</em>
                                                        </p>
                                                      )}

                                                      {slot.blocked_type === "shotgun_crossover" && (
                                                        <p className="text-center">
                                                          <FontAwesomeIcon
                                                            icon={faRepeatAlt}
                                                            className="booking-participant_icon"
                                                          />
                                                        </p>
                                                      )}
                                                    </div>
                                                  ) : (
                                                    <div>
                                                      <p className="text-center">
                                                        <FontAwesomeIcon
                                                          icon={faPlusCircle}
                                                          className="booking-participant_icon"
                                                        />
                                                      </p>
                                                    </div>
                                                  )}
                                                </div>
                                              </RightClickMenu>
                                            </TeeTimeToolTip>
                                          </div>
                                        );
                                      }
                                    }, // slot group map
                                  )}
                                </div> // tee-time-slots_container
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </span>
                    )}
                  </Droppable>
                </div>
                {!mobileSizedDivision && renderBookingCategoryIcons(teetime?.slots?.[0]?.tee_time_id)}
              </div>

              {/* SUNSET MARKER */}
              {((teetimeIndex === teetimes.length - 1 && sunsetLineTime > teetime?.start_time) ||
                (sunsetLineTime <= nextTeetime?.start_time && sunsetLineTime > teetime?.start_time)) && (
                <div className="flex items-center mt-3.5 mb-3.5">
                  <div className="sun-time-line"></div>
                  <span className="sun-time-hour">
                    <FontAwesomeIcon icon={faSunset} className="booking-participant_icon mt-1" />
                    {convertTime(facilityStore.weather?.sunset)}
                  </span>
                  <div style={{ marginRight: "8px" }} className="sun-time-line"></div>
                </div>
              )}
            </div>
          </Fragment>
        );
      })}

      <Portal isMounted={copyLeagueBookings?.isOpen}>
        <Sheet
          open={copyLeagueBookings?.isOpen}
          title={t("Copy League Bookings")}
          onCancel={closeCopyLeagueBookings}
          onOk={putCopyLeagueBookings}
          okText={t("Copy")}
          size="small"
          overflow
          okDisabled={
            !copyLeagueBookings?.copyStatus ||
            copyLeagueBookings?.selectedDate?.getDate() === (teeSheetStore?.selectedDate as Date)?.getDate() ||
            copyLeagueBookings?.copyStatus?.copy_status === "none"
          }
          closable
        >
          <DatePickerInput
            months={1}
            label={t("Date to Copy League Bookings to")}
            position="right"
            startingDate={copyLeagueBookings.selectedDate}
            setStartingDate={(date: Date) => updateCopyLeagueBookings({ selectedDate: date })}
            disablePastDays
          />
          {copyLeagueBookings?.selectedDate?.getDate() === (teeSheetStore?.selectedDate as Date)?.getDate() ? (
            <>
              <br />
              <Callout
                title="Select a Day"
                type="info"
                content={t("Select a day to copy the selected league's bookings to")}
              />
            </>
          ) : (
            <>
              {!copyLeagueBookings?.copyStatus &&
              copyLeagueBookings?.selectedDate?.getDate() !== (teeSheetStore?.selectedDate as Date)?.getDate() ? (
                <span style={{ display: "inline-flex", width: "100%", justifyContent: "center" }}>
                  <Spin />
                  <p className="ml-2">{t("Checking copy status...")}</p>
                </span>
              ) : null}
              <br />
              {copyLeagueBookings?.copyStatus?.copy_status === "none" ? (
                <Callout
                  title="Unable to Copy Bookings"
                  type="error"
                  content={t(
                    "There are no valid league tee times on the selected date to copy the selected bookings to",
                  )}
                />
              ) : null}

              {copyLeagueBookings?.copyStatus?.copy_status === "all" ? (
                <Callout
                  title="All Tee Times Are Valid"
                  type="success"
                  content={t(
                    "Every booking within the selected league is able to be successfully copied over to the selected date",
                  )}
                />
              ) : null}

              {copyLeagueBookings?.copyStatus?.copy_status === "partial" ? (
                <>
                  <Callout
                    title="Some Tee Times Are Valid"
                    type="warning"
                    content={t("Some tee times are unavailable on the selected date. Only some bookings can be copied")}
                  />
                  <p className="tee-sheet-leagues-copy-text">
                    {t("Bookings on the following tee times will be copied to the selected date: ")}
                  </p>
                  <div className="tee-sheet-leagues-copy-tags-container">
                    {copyLeagueBookings?.copyStatus?.results?.map((status, index) => {
                      return (
                        <div key={index} className="tee-sheet-leagues-copy-tag">
                          <p className="tee-sheet-leagues-copy-tag-text">
                            {moment(status?.start_time, "HH:mm")?.format("LT")}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : null}
            </>
          )}
        </Sheet>
      </Portal>

      <Portal isMounted={editGroupNameModal?.isOpen}>
        <Sheet
          open={editGroupNameModal?.isOpen}
          title={t("Edit Group Name")}
          size="small"
          onCancel={closeEditGroupNameModal}
          onOk={updateBookingGroupName}
          okText={t("Save")}
        >
          <FormLayout>
            <FormLayout.Group>
              <Input
                label={t("Group Name")}
                placeholder={t("Group Name")}
                value={editGroupNameModal.groupName}
                onChange={e => updateEditGroupNameModal({ groupName: e?.target?.value })}
              />
            </FormLayout.Group>
          </FormLayout>
        </Sheet>
      </Portal>

      <Portal isMounted={cancelGroupBookingsModal?.isOpen}>
        <Popup
          open={cancelGroupBookingsModal?.isOpen}
          title={t("Cancel Group Bookings")}
          type="warning"
          description={t("Are you sure you want to cancel all bookings within this group?")}
          onCancel={closeCancelGroupBookingsModal}
          onOk={cancelBookingGroup}
        >
          <div className="mt-3">
            <Checkbox
              id={"send_cancellation_email"}
              size="small"
              checked={cancelGroupBookingsModal.cancelEmail}
              onChange={e => updateCancelGroupBookingsModal({ cancelEmail: e.target?.checked })}
              label={t("Cancellation Email")}
            />
          </div>
        </Popup>
      </Portal>
    </div>
  );
}
